{
  "about.blocks": "Shërbyes të moderuar",
  "about.contact": "Kontakt:",
  "about.default_locale": "Parazgjedhje",
  "about.disclaimer": "Mastodon-i është software i lirë, me burim të hapët dhe shenjë tregtare e Mastodon gGmbH.",
  "about.domain_blocks.no_reason_available": "S’ka arsye",
  "about.domain_blocks.preamble": "Mastodon-i ju lë përgjithësisht të shihni lëndë prej përdoruesish dhe të ndërveproni me ta nga cilido shërbyes tjetër qofshin në fedivers. Ka përjashtime që janë bërë në këtë shërbyes të dhënë.",
  "about.domain_blocks.silenced.explanation": "Përgjithësisht s’do të shihni profile dhe lëndë nga ky shërbyes, veç në i kërkofshi shprehimisht apo zgjidhni të bëhet kjo, duke i ndjekur.",
  "about.domain_blocks.silenced.title": "E kufizuar",
  "about.domain_blocks.suspended.explanation": "S’do të përpunohen, depozitohen apo shkëmbehen të dhëna të këtij shërbyesi, duke e bërë të pamundur çfarëdo ndërveprimi apo komunikimi me përdorues nga ky shërbyes.",
  "about.domain_blocks.suspended.title": "E pezulluar",
  "about.language_label": "Gjuhë",
  "about.not_available": "Ky informacion, në këtë shërbyes, nuk jepet.",
  "about.powered_by": "Media shoqërore e decentralizuar, bazuar në {mastodon}",
  "about.rules": "Rregulla shërbyesi",
  "account.account_note_header": "Shënim personal",
  "account.activity": "Veprimtari",
  "account.add_note": "Shtoni një shënim personal",
  "account.add_or_remove_from_list": "Shtoni ose Hiqni prej listash",
  "account.badges.admin": "Përgjegjës",
  "account.badges.blocked": "E bllokuar",
  "account.badges.bot": "Robot",
  "account.badges.domain_blocked": "Përkatësi e bllokuar",
  "account.badges.group": "Grup",
  "account.badges.muted": "E heshtuar",
  "account.badges.muted_until": "Heshtuar deri më {until}",
  "account.block": "Blloko @{name}",
  "account.block_domain": "Blloko përkatësinë {domain}",
  "account.block_short": "Bllokoje",
  "account.blocked": "E bllokuar",
  "account.cancel_follow_request": "Tërhiq mbrapsht kërkesë për ndjekje",
  "account.copy": "Kopjoje lidhjen te profili",
  "account.direct": "Përmendje private për @{name}",
  "account.disable_notifications": "Resht së njoftuari mua, kur poston @{name}",
  "account.edit_note": "Përpunoni shënim personal",
  "account.edit_profile": "Përpunoni profilin",
  "account.edit_profile_short": "Përpunojeni",
  "account.enable_notifications": "Njoftomë, kur poston @{name}",
  "account.endorse": "Pasqyrojeni në profil",
  "account.familiar_followers_many": "Ndjekur nga {name1}, {name2} dhe {othersCount, plural, one {një tjetër që njihni} other {# të tjerë që njihni}}",
  "account.familiar_followers_one": "Ndjekur nga {name1}",
  "account.familiar_followers_two": "Ndjekur nga {name1} dhe {name2}",
  "account.featured": "Të zgjedhur",
  "account.featured.accounts": "Profile",
  "account.featured.collections": "Koleksione",
  "account.featured.new_collection": "Koleksion i ri",
  "account.field_overflow": "Shfaq lëndë të plotë",
  "account.filters.all": "Krejt veprimtarinë",
  "account.filters.boosts_toggle": "Shfaq përforcime",
  "account.filters.posts_boosts": "Postime dhe përforcime",
  "account.filters.posts_only": "Postime",
  "account.filters.posts_replies": "Postime dhe përgjigje",
  "account.filters.replies_toggle": "Shfaq përgjigje",
  "account.follow": "Ndiqeni",
  "account.follow_back": "Ndiqe gjithashtu",
  "account.follow_back_short": "Ndiqe gjithashtu",
  "account.follow_request": "Kërkoni ta ndiqni",
  "account.follow_request_cancel": "Anuloje kërkesën",
  "account.follow_request_cancel_short": "Anuloje",
  "account.follow_request_short": "Kërkoje",
  "account.followers": "Ndjekës",
  "account.followers.empty": "Këtë përdorues ende s’e ndjek kush.",
  "account.followers_counter": "{count, plural, one {{counter} ndjekës} other {{counter} ndjekës}}",
  "account.followers_you_know_counter": "{counter} që njihni",
  "account.following": "Ndjekje",
  "account.following_counter": "{count, plural, one {{counter} i ndjekur} other {{counter} të ndjekur}}",
  "account.follows.empty": "Ky përdorues ende s’ndjek kënd.",
  "account.follows_you": "Ju ndjek",
  "account.go_to_profile": "Kalo te profili",
  "account.hide_reblogs": "Fshih përforcime nga @{name}",
  "account.in_memoriam": "In Memoriam.",
  "account.join_modal.day": "Ditë",
  "account.join_modal.me": "U bëtë pjesë e {server} më",
  "account.join_modal.me_anniversary": "Gëzuar përvjetorin në Fedivers! U bëtë pjesë e {server} më",
  "account.join_modal.me_today": "Është dita jua e parë në {server}!",
  "account.join_modal.other": "{name} erdhi në {server} më",
  "account.join_modal.other_today": "Është dita e parë në {server} për {name}!",
  "account.join_modal.share.celebrate": "Ndani me të tjerë një postim kremtimi",
  "account.join_modal.share.intro": "Ndani me të tjerë një postim hyrës",
  "account.join_modal.share.welcome": "Mdani me të tjerë një postim mirëseardhjeje",
  "account.join_modal.years": "{number, plural, one {vit} other {vjet}}",
  "account.joined_short": "U bë pjesë",
  "account.languages": "Ndryshoni gjuhë pajtimesh",
  "account.last_active": "Aktiv së fundi më",
  "account.link_verified_on": "Pronësia e kësaj lidhjeje qe kontrolluar më {date}",
  "account.locked_info": "Gjendja e privatësisë së kësaj llogarie është caktuar si e kyçur. I zoti merr dorazi në shqyrtim cilët mund ta ndjekin.",
  "account.media": "Media",
  "account.mention": "Përmendni @{name}",
  "account.menu.add_to_list": "Shtoni në listë…",
  "account.menu.block": "Bllokoje llogarinë",
  "account.menu.block_domain": "Bllokoje {domain}",
  "account.menu.copied": "Lidhja e llogarisë u kopjua në të papastër",
  "account.menu.copy": "Kopjoji lidhjen",
  "account.menu.direct": "Përmendje privatish",
  "account.menu.hide_reblogs": "Fshihi përforcimet te rrjedhë kohore",
  "account.menu.mention": "Përmendje",
  "account.menu.mute": "Heshtoje llogarinë",
  "account.menu.note.description": "I dukshëm vetëm për ju",
  "account.menu.open_original_page": "Shiheni në {domain}",
  "account.menu.remove_follower": "Hiqni ndjekës",
  "account.menu.report": "Raportoni llogari",
  "account.menu.share": "Ndajeni me të tjerë…",
  "account.menu.show_reblogs": "Shfaqi përforcimet në rrjedhë kohore",
  "account.menu.unblock": "Zhbllokoje llogarinë",
  "account.menu.unblock_domain": "Zhbllokoje {domain}",
  "account.menu.unmute": "Hiqja heshtimin llogarinë",
  "account.moved_to": "{name} ka treguar se llogari e vet e re tani është:",
  "account.mute": "Heshtoje @{name}",
  "account.mute_notifications_short": "Mos shfaq njoftime",
  "account.mute_short": "Mos i shfaq",
  "account.muted": "Heshtuar",
  "account.mutual": "Ndiqni njëri-tjetrin",
  "account.name.help.domain": "{domain} është shërbyesi që strehon profilin dhe postimet e përdoruesit.",
  "account.name.help.domain_self": "{domain} është shërbyesi juaj që strehon profilin dhe postimet tuaja.",
  "account.name.help.footer": "Ashtu si mund të dërgoni email-e te persona që përdorin shërbime të ndryshme email-i, ashtu mund të ndërveproni me persona në shërbyes të tjerë Mastodon dhe me këdo në aplikacione të tjerë Fediverse.",
  "account.name.help.header": "Handle-i është i ngashëm me një adresë email",
  "account.name.help.username": "{username} është emri i përdoruesit të kësaj llogarie në shërbyesin e tij. Dikush në një tjetër shërbyes mund të ketë të njëjtin emër përdoruesi.",
  "account.name.help.username_self": "{username} është emri juaj i përdoruesit në këtë shërbyes. Dikush në një tjetër shërbyes mund të ketë të njëjtin emër përdoruesi.",
  "account.name_info": "Ç’do të thotë kjo?",
  "account.no_bio": "S’u dha përshkrim.",
  "account.node_modal.callout": "Shënimet personale janë të dukshme vetëm për ju.",
  "account.node_modal.edit_title": "Përpunoni shënim personal",
  "account.node_modal.error_unknown": "S’u ruajt dot shënimi",
  "account.node_modal.field_label": "Shënim Personal",
  "account.node_modal.save": "Ruaje",
  "account.node_modal.title": "Shtoni një shënim personal",
  "account.note.edit_button": "Përpunojeni",
  "account.note.title": "Shënim personal (i dukshëm vetëm për ju)",
  "account.open_original_page": "Hap faqen origjinale",
  "account.pending": "Në pritje të shqyrtimit",
  "account.posts": "Mesazhe",
  "account.remove_from_followers": "Hiqe {name} nga ndjekësit",
  "account.report": "Raportojeni @{name}",
  "account.requested_follow": "{name} ka kërkuar t’ju ndjekë",
  "account.share": "Ndajeni profilin e @{name} me të tjerët",
  "account.show_reblogs": "Shfaq përforcime nga @{name}",
  "account.statuses_counter": "{count, plural, one {{counter} postim} other {{counter} postime}}",
  "account.timeline.pinned": "I fiksuar",
  "account.timeline.pinned.view_all": "Shihni krejt postimet e fiksuara",
  "account.unblock": "Zhbllokoje @{name}",
  "account.unblock_domain": "Zhblloko përkatësinë {domain}",
  "account.unblock_domain_short": "Zhbllokoje",
  "account.unblock_short": "Zhbllokoje",
  "account.unendorse": "Mos e përfshi në profil",
  "account.unfollow": "Resht së ndjekuri",
  "account.unmute": "Ktheji zërin @{name}",
  "account.unmute_notifications_short": "Shfaqi njoftimet",
  "account.unmute_short": "Çheshtoje",
  "account_edit.advanced_settings.bot_hint": "Sinjalizojuni të tjerëve se llogari kryesisht kryen veprime të automatizuara dhe mund të mos vëzhgohet",
  "account_edit.advanced_settings.bot_label": "Llogari e automatizuar",
  "account_edit.advanced_settings.title": "Rregullime të mëtejshme",
  "account_edit.bio.add_label": "Shtoni jetëshkrim",
  "account_edit.bio.edit_label": "Përpunoni jetëshkrim",
  "account_edit.bio.placeholder": "Shtoni një hyrje të shkurtër për të ndihmuar të tjerët t’ju identifikojnë.",
  "account_edit.bio.title": "Jetëshkrim",
  "account_edit.bio_modal.add_title": "Shtoni jetëshkrim",
  "account_edit.bio_modal.edit_title": "Përpunoni jetëshkrim",
  "account_edit.column_button": "U bë",
  "account_edit.column_title": "Përpunoni Profil",
  "account_edit.custom_fields.add_label": "Shtoni fushë",
  "account_edit.custom_fields.edit_label": "Përpunoni fushë",
  "account_edit.custom_fields.placeholder": "Shtoni përemrat tuaj, lidhje të jashme, ose gjithçka tjetë që do të donit të ndanit me të tjerë.",
  "account_edit.custom_fields.reorder_button": "Rirenditi fushat",
  "account_edit.custom_fields.tip_content": "Mundeni të shtoni kollak besueshmëri për llogarinë tuaj Mastodon duke verifikuar lidhje për te çfarëdo sajti që është pronë e juaja.",
  "account_edit.custom_fields.tip_title": "Ndihmëz: Duke shtuar lidhje të verifikuara",
  "account_edit.custom_fields.title": "Fusha vetjake",
  "account_edit.custom_fields.verified_hint": "Si të shtoj një lidhje të verifikuar?",
  "account_edit.display_name.add_label": "Shtoni emër në ekran",
  "account_edit.display_name.edit_label": "Përpunoni emër në ekran",
  "account_edit.display_name.placeholder": "Emri juaj në ekran është ajo si duket emri juaj në profilikin dhe rrjedhat tuaja kohore.",
  "account_edit.display_name.title": "Emër në ekran",
  "account_edit.featured_hashtags.edit_label": "Shtoni hashtag-ë",
  "account_edit.featured_hashtags.placeholder": "Ndihmoni të tjerët të identifikojnë dhe të hyjnë shpejt e shpejt te subjektet tuaj të parapëlqyer.",
  "account_edit.featured_hashtags.title": "Hashtag-ë të zgjedhur",
  "account_edit.field_actions.delete": "Fshije fushën",
  "account_edit.field_actions.edit": "Përpunoni fushën",
  "account_edit.field_delete_modal.confirm": "Jeni i sigurt se doni të fshihet kjo fushë e përshtatur? Ky veprim s’mund të zhbëhet.",
  "account_edit.field_delete_modal.delete_button": "Fshije",
  "account_edit.field_delete_modal.title": "Të fshihet fushë e përshtatur?",
  "account_edit.field_edit_modal.add_title": "Shtoni fushë të përshtatur",
  "account_edit.field_edit_modal.discard_confirm": "Hidhe tej",
  "account_edit.field_edit_modal.discard_message": "Keni ndryshime të paruajtura. Jeni i sigurt se doni të hidhen tej?",
  "account_edit.field_edit_modal.edit_title": "Përpunoni fushë të përshtatur",
  "account_edit.field_edit_modal.length_warning": "U tejkaluar kufi i rekomanduar shenjash. Përdorues në celular mund të mos shohin të plotë fushën tuaj.",
  "account_edit.field_edit_modal.link_emoji_warning": "Rekomandojmë të mos përdoren emoji të përshtatur tok me url-ra. Fusha të përshtatura që i përmbajnë të dyja llojetn do t’i shfaqin si tekst, në vend se si një lidhje, për të parandaluar ngatërrim të përdoruesve.",
  "account_edit.field_edit_modal.name_hint": "P.sh., “Sajt personal”",
  "account_edit.field_edit_modal.name_label": "Etiketë",
  "account_edit.field_edit_modal.url_warning": "Që të shtoni një lidhje, ju lutemi, përfshini {protocol} në fillim.",
  "account_edit.field_edit_modal.value_hint": "P.sh., “https://example.me”",
  "account_edit.field_edit_modal.value_label": "Vlerë",
  "account_edit.field_reorder_modal.drag_cancel": "Tërheqja u anulua. Fusha “{item}” u la jashtë.",
  "account_edit.field_reorder_modal.drag_instructions": "Që të risistemoni fusha vetjake, shtypni tastin Space, ose Enter. Teksa tërhiqen, përdorni tastet shigjetë që të lëvizn fushat lart ose poshtë. Shtypni sërish tastin Space ose Enter që të lihet fusha te pozicioni i saj i ri, ose shtypni tastin Esc, që të anulohet.",
  "account_edit.field_reorder_modal.drag_move": "Fusha “{item}” u lëviz.",
  "account_edit.field_reorder_modal.drag_over": "Fusha “{item}” u kaluar sipër “{over}”.",
  "account_edit.field_reorder_modal.drag_start": "U mor fusha “{item}”.",
  "account_edit.field_reorder_modal.handle_label": "Tërhiqni fushën “{item}”",
  "account_edit.field_reorder_modal.title": "Risistemoni fusha",
  "account_edit.image_alt_modal.add_title": "Shtoni tekst alternativ",
  "account_edit.image_alt_modal.details_content": "MIRË: <ul> <li>Përshkruani veten si në figurë</li> <li>Përdorni gjuhë në vetën e tretë (p.sh., “Gimi”, në vend se “unë”)</li> <li>Jini konciz – pak fjalë shpesh mjaftojnë</li> </ul> KEQ: <ul> <li>T’ia filloni me “Foto e ” – është përsëritje për lexues ekrani</li> </ul> SHEMBULL: <ul> <li>“Gimi me një këmishë të gjelbër dhe syze”</li> </ul>",
  "account_edit.image_alt_modal.details_title": "Ndihmëza: Teskt alternativ për figura profilesh",
  "account_edit.image_alt_modal.edit_title": "Përpunoni tekst alternativ",
  "account_edit.image_alt_modal.text_hint": "Teskti alternativ ndihmon përdorue lexuesish ekrani të kuptojnë lëndën tuaj.",
  "account_edit.image_alt_modal.text_label": "Tekst alternativ",
  "account_edit.image_delete_modal.confirm": "Jeni i sigurt se doni të fshihet kjo figurë? Ky veprim s’mund të zhbëhet.",
  "account_edit.image_delete_modal.delete_button": "Fshije",
  "account_edit.image_delete_modal.title": "Të fshihet figura?",
  "account_edit.image_edit.add_button": "Shtoni figurë",
  "account_edit.image_edit.alt_add_button": "Shtoni tekst alternativ",
  "account_edit.image_edit.alt_edit_button": "Përpunoni tekst alternativ",
  "account_edit.image_edit.remove_button": "Hiqe figurën",
  "account_edit.image_edit.replace_button": "Zëvendësoje figurën",
  "account_edit.item_list.delete": "Fshije {name}",
  "account_edit.item_list.edit": "Përpunojeni {name}",
  "account_edit.name_modal.add_title": "Shtoni emër në ekran",
  "account_edit.name_modal.edit_title": "Përpunoni emër në ekran",
  "account_edit.profile_tab.button_label": "Përshtateni",
  "account_edit.profile_tab.hint.description": "Këto rregullime përshtasin ç’shohin përdoruesit në {server} te aplikacionet zyrtare, por mund të mos kenë vend për përdorues në shërbyes të tjerë dhe aplikacione nga palë të treta.",
  "account_edit.profile_tab.hint.title": "Ç’duket, ende varion",
  "account_edit.profile_tab.show_featured.description": "“Të zgjedhura” është një skedë opsionale ku mund të shpalosni llogari të tjera.",
  "account_edit.profile_tab.show_featured.title": "Shfaq skedë “Të zgjedhura”",
  "account_edit.profile_tab.show_media.description": "“Media” është një skedë opsionale që shfaq postime tuajat që përmbajnë figura ose video.",
  "account_edit.profile_tab.show_media.title": "Shfaq skedë “Media”",
  "account_edit.profile_tab.show_media_replies.description": "Kur aktivizohet, skeda Media shfaq si postimet tuaja, ashtu edhe përgjigje te postime nga persona të tjerë.",
  "account_edit.profile_tab.show_media_replies.title": "Përfshi te skeda “Media” përgjigje",
  "account_edit.profile_tab.show_relations.description": "Bën shfaqjen në profilin tuaj të llogarive që ndiqni dhe ndjekës te përdorues të tjerë. Personat do të jenë prapë në gjendje të shohin nëse i ndiqni a jo.",
  "account_edit.profile_tab.show_relations.title": "Shfaq “Ndjekës” dhe “Të ndjekur”",
  "account_edit.profile_tab.subtitle": "Përshtatni si shfaqet profili juaj.",
  "account_edit.profile_tab.title": "Rregullime shfaqjeje profili",
  "account_edit.save": "Ruaje",
  "account_edit.upload_modal.back": "Mbrapsht",
  "account_edit.upload_modal.done": "U bë",
  "account_edit.upload_modal.next": "Pasuesja",
  "account_edit.upload_modal.step_crop.zoom": "Zoom",
  "account_edit.upload_modal.step_upload.button": "Shfletoni kartela",
  "account_edit.upload_modal.step_upload.dragging": "Lëreni, që të ngarkohet",
  "account_edit.upload_modal.step_upload.header": "Zgjidhni një figurë",
  "account_edit.upload_modal.step_upload.hint": "Format WEBP, PNG, GIF ose JPG, deri në {limit}MB.{br}Figura do të ripërmasohet në {width}x{height}px.",
  "account_edit.upload_modal.title_add.avatar": "Shtoni foto profili",
  "account_edit.upload_modal.title_add.header": "Shtoni foto profili",
  "account_edit.upload_modal.title_replace.avatar": "Zëvendësoni foto profili",
  "account_edit.upload_modal.title_replace.header": "Zëvendësoni foto profili",
  "account_edit.verified_modal.details": "Shtoni besueshmëri te profili juaj Mastodon duke verifikuar lidhje për te sajte personalë. Ja se si funksionon:",
  "account_edit.verified_modal.invisible_link.details": "Shtojeni lidhjen te kryet tuaja. Pjesa e rëndësishme është rel=\"me\", e cila pengon imitime në sajte me lëndë të prodhuar nga përdoruesit. Mundeni madje të përdorni një etiketë lidhjeje te kryet e faqes në vend të {tag}, por HTML-ja duhet të jetë e përdorshme pa ekzekutim të JavaScript-it.",
  "account_edit.verified_modal.invisible_link.summary": "Si ta bëj lidhjen të padukshme?",
  "account_edit.verified_modal.step1.header": "Kopjoni kodin HTML më poshtë dhe ngjiteni te kryet e sajtit tuaj",
  "account_edit.verified_modal.step2.details": "Nëse e keni shtuar tashmë sajtin tuaj si një fushë të përshtatur, do t’ju duhet ta fshini dhe ta rishtoni, që të shkaktohet verifikimi.",
  "account_edit.verified_modal.step2.header": "Shtojeni sajtin tuaj si një fushë të përshtatur",
  "account_edit.verified_modal.title": "Si të shtohet një lidhje e verifikuar",
  "account_edit_tags.add_tag": "Shtoje #{tagName}",
  "account_edit_tags.column_title": "Përpunoni Etiketa",
  "account_edit_tags.help_text": "Hashtag-ët e zgjedhur i ndihmojnë përdoruesit të zbulojnë dhe ndërveprojnë me profilin tuaj. Ata duken si filtra te pamja Veprimtari e faqes tuaj të Profilit.",
  "account_edit_tags.max_tags_reached": "Keni mbërritur në numrin maksimum të hashtag-ëve të zgjedhur.",
  "account_edit_tags.search_placeholder": "Jepni një hashtag…",
  "account_edit_tags.suggestions": "Sugjerime:",
  "account_edit_tags.tag_status_count": "{count, plural, one {# postim} other {# postime}}",
  "account_list.hidden_notice": "Kjo është e dukshme vetëm për ju. Që t’ua shfaqni këtë listë të tjerëve, kaloni te <link>{page} > {modal} > {field}</link>.",
  "account_list.total": "{total, plural, one {# llogari} other {# llogari}}",
  "account_note.placeholder": "Klikoni për të shtuar shënim",
  "admin.dashboard.daily_retention": "Shkallë mbajtjeje përdoruesi, në ditë, pas regjistrimit",
  "admin.dashboard.monthly_retention": "Shkallë mbajtjeje përdoruesi, në muaj, pas regjistrimit",
  "admin.dashboard.retention.average": "Mesatare",
  "admin.dashboard.retention.cohort": "Muaj regjistrimi",
  "admin.dashboard.retention.cohort_size": "Përdorues të rinj",
  "admin.impact_report.instance_accounts": "Profile llogarish që kjo do të fshinte",
  "admin.impact_report.instance_followers": "Ndjekës që përdoruesit tanë do të humbnin",
  "admin.impact_report.instance_follows": "Ndjekës që përdoruesit e tyre do të humbnin",
  "admin.impact_report.title": "Përmbledhje ndikimi",
  "alert.rate_limited.message": "Ju lutemi, riprovoni pas {retry_time, time, medium}.",
  "alert.rate_limited.title": "Shpejtësi e kufizuar",
  "alert.unexpected.message": "Ndodhi një gabim të papritur.",
  "alert.unexpected.title": "Hëm!",
  "alt_text_badge.title": "Tekst alternativ",
  "alt_text_modal.add_alt_text": "Shtoni tekst alternativ",
  "alt_text_modal.add_text_from_image": "Shtoni tekst nga figura",
  "alt_text_modal.cancel": "Anuloje",
  "alt_text_modal.change_thumbnail": "Ndryshoni miniaturën",
  "alt_text_modal.describe_for_people_with_hearing_impairments": "Përshkruajeni këtë për persona me mangësi dëgjimi…",
  "alt_text_modal.describe_for_people_with_visual_impairments": "Përshkruajeni këtë për persona me mangësi shikimi…",
  "alt_text_modal.done": "U bë",
  "announcement.announcement": "Lajmërim",
  "annual_report.announcement.action_build": "Krijo Përmbledhjedon-in tim",
  "annual_report.announcement.action_dismiss": "Jo, faleminderit",
  "annual_report.announcement.action_view": "Parje e Përmbledhjedon-it tim",
  "annual_report.announcement.description": "Zbuloni më tepër rreth angazhimit tuaj në Mastodon gjatë vitit të shkuar.",
  "annual_report.announcement.title": "Përmbledhjedon {year} erdhi",
  "annual_report.nav_item.badge": "E re",
  "annual_report.shared_page.donate": "Dhuroni",
  "annual_report.shared_page.footer": "Hartuar me {heart} nga ekipi i Mastodon-it",
  "annual_report.shared_page.footer_server_info": "{username} përdor {domain}, një nga bashkësitë e shumta të bazuara në Mastodon.",
  "annual_report.summary.archetype.booster.desc_public": "{name} gjuajti postime për përforcim, duke amplifikuar krijues të tjerë me nishan të përsosur.",
  "annual_report.summary.archetype.booster.desc_self": "Gjuajtët postime për përforcim, duke amplifikuar krijues të tjerë me nishan të përsosur.",
  "annual_report.summary.archetype.booster.name": "Harkëtari",
  "annual_report.summary.archetype.die_drei_fragezeichen": "???",
  "annual_report.summary.archetype.lurker.desc_public": "E dimë se {name} qe vërdallë, diku, duke shijuar Mastodon-in në mënyrën e vet të qetë.",
  "annual_report.summary.archetype.lurker.desc_self": "E dimë se qetë vërdallë, diku, duke shijuar Mastodon-in në mënyrën tuaj të qetë.",
  "annual_report.summary.archetype.lurker.name": "Stoiku",
  "annual_report.summary.archetype.oracle.desc_public": "{name} krijoi postime të reja, më shumë se përgjigje, duke e mbajtur Mastodon-in të freskët dhe me sytë nga ardhmja.",
  "annual_report.summary.archetype.oracle.desc_self": "Krijuat postime të reja, më shumë se përgjigje, duke e mbajtur Mastodon-in të freskët dhe me sytë nga e ardhmja.",
  "annual_report.summary.archetype.oracle.name": "Orakulli",
  "annual_report.summary.archetype.pollster.desc_public": "{name} krijoi më tepër pyetësorë se sa lloje të tjera postimesh, duke kultivuar kureshtjen në Mastodon.",
  "annual_report.summary.archetype.pollster.desc_self": "Krijuat më tepër pyetësorë, se sa lloje të tjera postimesh, duke kultivuar kureshtjen në Mastodon.",
  "annual_report.summary.archetype.replier.desc_public": "{name} u përgjigj shpesh te postime të njerëzve të tjerë, duke pjalmuar Mastodon-in me diskutime të reja.",
  "annual_report.summary.archetype.replier.desc_self": "U përgjigjët shpesh te postime të njerëzve të tjerë, duke pjalmuar Mastodon-in me diskutime të reja.",
  "annual_report.summary.archetype.replier.name": "Flutura",
  "annual_report.summary.archetype.reveal": "Zbulo me se ngjaj",
  "annual_report.summary.archetype.reveal_description": "Faleminderit për qenien pjesë e Mastodon-it! Koha për të mësuar cilin model trupëzuat gjatë {year}.",
  "annual_report.summary.archetype.title_public": "Modeli për {name}",
  "annual_report.summary.archetype.title_self": "Modeli juaj",
  "annual_report.summary.close": "Mbylle",
  "annual_report.summary.copy_link": "Kopjoji lidhjen",
  "annual_report.summary.followers.new_followers": "{count, plural, one {ndjekës i ri} other {ndjekës të rinj}}",
  "annual_report.summary.highlighted_post.boost_count": "Ky postim qe përforcuar {count, plural, one {një herë} other {# herë}}.",
  "annual_report.summary.highlighted_post.favourite_count": "Ky postim u vu si i parapëlqyer {count, plural, one {një herë} other {# herë}}.",
  "annual_report.summary.highlighted_post.reply_count": "Ky postim pati {count, plural, one {një përgjigje} other {# përgjigje}}.",
  "annual_report.summary.highlighted_post.title": "Postimi më popullor",
  "annual_report.summary.most_used_app.most_used_app": "aplikacioni më i përdorur",
  "annual_report.summary.most_used_hashtag.most_used_hashtag": "hashtag-u më i përdorur",
  "annual_report.summary.most_used_hashtag.used_count": "Këtë hashtag e përfshitë në {count, plural, one {një postim} other {# postime}}.",
  "annual_report.summary.most_used_hashtag.used_count_public": "{name} përfshiu këtë hashtag në {count, plural, one {një postim} other {# postime}}.",
  "annual_report.summary.new_posts.new_posts": "postime të reja",
  "annual_report.summary.percentile.text": "<topLabel>Kjo ju vendos te</topLabel><percentage></percentage><bottomLabel> kryesues të përdoruesve të {domain}.</bottomLabel>",
  "annual_report.summary.percentile.we_wont_tell_bernie": "Nuk do t’ia themi Bernit.",
  "annual_report.summary.share_elsewhere": "Ndajeni me të tjerë gjetkë",
  "annual_report.summary.share_on_mastodon": "Ndajeni në Mastodon me të tjerë",
  "attachments_list.unprocessed": "(e papërpunuar)",
  "audio.hide": "Fshihe audion",
  "block_modal.no_collections": "Asnjë prej jush s’mund shtojë tjetrin te koleksione. Do të hiqeni automatikisht nga koleksionne ekzistuese të njëri-tjetrit, nëse ka vend.",
  "block_modal.remote_users_caveat": "Do t’i kërkojmë shërbyesit {domain} të respektojë vendimin tuaj. Por, pajtimi s’është i garantuar, ngaqë disa shërbyes mund t’i trajtojnë ndryshe bllokimet. Psotimet publike mundet të jenë ende të dukshme për përdorues pa bërë hyrje në llogari.",
  "block_modal.show_less": "Shfaq më pak",
  "block_modal.show_more": "Shfaq më tepër",
  "block_modal.they_cant_mention": "S’mund të përmendni, ndiqni, ose citoni njëri-tjetrin.",
  "block_modal.they_cant_see_posts": "S’mund të shohin lëndën tuaj dhe ju s’do të shihni të tyren.",
  "block_modal.they_will_know": "Mund të shohin se janë bllokuar.",
  "block_modal.title": "Të bllokohet përdoruesi?",
  "block_modal.you_wont_see_mentions": "S’do të shihni postime nga të tjerë që i përmendin ata.",
  "boost_modal.combo": "Që kjo të anashkalohet herës tjetër, mund të shtypni {combo}",
  "boost_modal.reblog": "Përforcim postimi?",
  "boost_modal.undo_reblog": "Të hiqet përforcim për postimin?",
  "bundle_column_error.copy_stacktrace": "Kopjo raportim gabimi",
  "bundle_column_error.error.body": "Faqja e kërkuar s’u vizatua dot. Kjo mund të vijë nga një e metë në kodin tonë, ose nga një problem përputhshmërie i shfletuesit.",
  "bundle_column_error.error.title": "Oh, mos!",
  "bundle_column_error.network.body": "Pati një gabim teksa provohej të ngarkohej kjo faqe. Kjo mund të vijë për shkak të një problemi të përkohshëm me lidhjen tuaj internet ose me këtë shërbyes.",
  "bundle_column_error.network.title": "Gabim rrjeti",
  "bundle_column_error.retry": "Riprovoni",
  "bundle_column_error.return": "Shko mbrapsht te kreu",
  "bundle_column_error.routing.body": "Faqja e kërkuar s’u gjet dot. Jeni i sigurt se URL-ja te shtylla e adresave është e saktë?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Mbylle",
  "bundle_modal_error.message": "Diç shkoi ters, teksa ngarkohej kjo skenë.",
  "bundle_modal_error.retry": "Riprovoni",
  "callout.dismiss": "Hidhe tej",
  "carousel.current": "<sr>Diapozitivi</sr> {current, number} / {max, number}",
  "carousel.slide": "Diapozitivi {current, number} nga {max, number} gjithsej",
  "character_counter.recommended": "{currentLength}/{maxLength} shenja e rekomanduara",
  "character_counter.required": "{currentLength}/{maxLength} shenja",
  "closed_registrations.other_server_instructions": "Ngaqë Mastodon-i është i decentralizuar, mund të krijoni një llogari në një tjetër shërbyes dhe prapë të ndëveproni me këtë këtu.",
  "closed_registrations_modal.description": "Krijimi i një llogarie te {domain} aktualisht është i pamundur, por kini parasysh se s’keni nevojë për një llogari posaçërisht në {domain} që të përdorni Mastodon-in.",
  "closed_registrations_modal.find_another_server": "Gjeni shërbyes tjetër",
  "closed_registrations_modal.preamble": "Mastodon-i është i decentralizuar, ndaj pavarësisht se ku krijoni llogarinë tuaj, do të jeni në gjendje të ndiqni dhe ndërveproni me këdo në këtë shërbyes. Mundeni madje edhe ta strehoni ju vetë!",
  "closed_registrations_modal.title": "Po regjistroheni në Mastodon",
  "collection.share_modal.share_via_post": "Postoje në Mastodon",
  "collection.share_modal.share_via_system": "Ndajeni me të tjerë në…",
  "collection.share_modal.title": "Ndani koleksionin me të tjerë",
  "collection.share_modal.title_new": "Ndani me të tjerë koleksionin tuaj të ri!",
  "collection.share_template_other": "Shihni këtë koleksion të hijshëm: {link}",
  "collection.share_template_own": "Shihni koleksionin tim të ri: {link}",
  "collections.account_count": "{count, plural, one {# llogari} other {# llogari}}",
  "collections.accounts.empty_description": "Shtoni deri në {count} llogari",
  "collections.accounts.empty_editor_title": "Në këtë koleksion s’ka ende njeri",
  "collections.accounts.empty_title": "Ky koleksion është i zbrazët",
  "collections.block_collection_owner": "Bllokoje llogarinë",
  "collections.by_account": "nga {account_handle}",
  "collections.collection_description": "Përshkrim",
  "collections.collection_language": "Gjuhë",
  "collections.collection_language_none": "Asnjë",
  "collections.collection_name": "Emër",
  "collections.collection_topic": "Temë",
  "collections.confirm_account_removal": "Jeni i sigurt se doni të hiqet kjo llogari nga ky koleksion?",
  "collections.content_warning": "Sinjalizim lënde",
  "collections.continue": "Vazhdo",
  "collections.copy_link": "Kopjoji lidhjen",
  "collections.copy_link_confirmation": "U kopjua në të papastër lidhja e koleksionit",
  "collections.create.accounts_title": "Kë do të shfaqni në këtë koleksion?",
  "collections.create.basic_details_title": "Hollësi bazë",
  "collections.create.steps": "Hapi {step}/{total}",
  "collections.create_collection": "Krijoni koleksion",
  "collections.delete_collection": "Fshije koleksionin",
  "collections.description_length_hint": "Kufi prej 100 shenjash",
  "collections.detail.author_added_you_on_date": "{author} ju shtoi më {date}",
  "collections.detail.loading": "Po ngarkohet koleksion…",
  "collections.detail.revoke_inclusion": "Hiqmëni",
  "collections.detail.sensitive_content": "Lëndë rezervat",
  "collections.detail.sensitive_note": "Ky koleksion përmban llogari dhe lëndë që mund të jetë me spec për disa përdorues.",
  "collections.detail.share": "Ndajeni këtë koleksion me të tjerë",
  "collections.detail.you_are_in_this_collection": "Shfaqeni te ky koleksion",
  "collections.edit_details": "Përpunoni hollësi",
  "collections.error_loading_collections": "Pati një gabim teksa provohej të ngarkoheshin këto koleksione.",
  "collections.hidden_accounts_description": "Bllokuat, ose heshtuat {count, plural, one {këtë përdorues} other {këta përdorues}}",
  "collections.hidden_accounts_link": "{count, plural, one {# llogari e fshehur} other {# llogari të fshehura}}",
  "collections.hints.accounts_counter": "{count}/{max} llogari",
  "collections.last_updated_at": "Përditësuar së fundi më: {date}",
  "collections.list.collections_with_count": "{count, plural, one {# Koleksion} other {# Koleksione}}",
  "collections.list.created_by_author": "Krijuar nga {name}",
  "collections.list.created_by_you": "Krijuar nga ju",
  "collections.list.featuring_you": "Që ju përmban",
  "collections.manage_accounts": "Administroni llogari",
  "collections.mark_as_sensitive": "Vëri shenjë si rezervat",
  "collections.mark_as_sensitive_hint": "Bën fshehjen e përshkrimit të koleksionit dhe llogarive prapa një sinjalizimi lënde. Emri i koleksionit do të jetë ende i dukshëm.",
  "collections.maximum_collection_count_description": "Shërbyesi juaj lejon krijimin e deri në {count} koleksioneve.",
  "collections.maximum_collection_count_reached": "Keni krijuar një numër maksimum koleksionesh",
  "collections.name_length_hint": "Kufi 40 shenja",
  "collections.new_collection": "Koleksion i ri",
  "collections.pending_accounts.message": "Llogaritë mund të shfaqen si në pritje të shqyrtimit, kur pritet një përgjigje nga përdoruesi, ose shërbyesi i tij. Llogari në pritje të shqyrtimit mund të shihni vetëm ju.",
  "collections.pending_accounts.title": "Pse shoh llogari në pritje të shqyrtimit?",
  "collections.remove_account": "Hiqe",
  "collections.report_collection": "Raportojeni këtë koleksion",
  "collections.revoke_collection_inclusion": "Hiqmëni nga ky koleksion",
  "collections.revoke_inclusion.confirmation": "U hoqët nga “{collection}”",
  "collections.revoke_inclusion.error": "Pati një gabim, ju lutemi, riprovoni më vonë.",
  "collections.search_accounts_label": "Kërkoni për një llogari për t’u shtuar",
  "collections.search_accounts_max_reached": "Keni shtuar numrin maksimum të llogarive",
  "collections.sensitive": "Rezervat",
  "collections.share_short": "Ndajeni me të tjerë",
  "collections.suggestions.can_not_add": "S’mund të shtohet",
  "collections.suggestions.can_not_add_desc": "Këto llogari kanë zgjedhur të lihen jashtë zbulimi, ose mund të gjenden në një shërbyes që s’mbulon koleksione.",
  "collections.suggestions.must_follow": "Duhet të ndjekin së pari",
  "collections.suggestions.must_follow_desc": "Këto llogari shqyrtojnë krejt kërkesat për ndjekje. Ndjekësit mund t’i shtojnë te koleksione.",
  "collections.topic_hint": "Shtoni një hashtag që ndihmon të tjerët të kuptojnë temën kryesore të këtij koleksion.",
  "collections.topic_special_chars_hint": "Shenjat e posaçme do të hiqen, kur ruhet",
  "collections.unlisted_collections_description": "Këto nuk shfaqen në profilin tuaj për të tjerët. Cilido me lidhjen mund t’i zbulojë.",
  "collections.unlisted_collections_with_count": "Koleksione të pashfaqur ({count})",
  "collections.view_collection": "Shiheni koleksionin",
  "collections.visibility_public": "Publik",
  "collections.visibility_public_hint": "I zbulueshëm në përfundime kërkimi dhe fusha të tjera ku shfaqen rekomandime.",
  "collections.visibility_title": "Dukshmëri",
  "collections.visibility_unlisted": "Jo në listë",
  "collections.visibility_unlisted_hint": "I dukshëm për këdo me një lidhje. I fshehur nga përfundime kërkimi dhe rekomandime.",
  "column.about": "Mbi",
  "column.blocks": "Përdorues të bllokuar",
  "column.bookmarks": "Faqerojtës",
  "column.community": "Rrjedhë kohore vendore",
  "column.create_list": "Krijo listë",
  "column.direct": "Përmendje private",
  "column.directory": "Shfletoni profile",
  "column.domain_blocks": "Përkatësi të bllokuara",
  "column.edit_list": "Përpunoni listën",
  "column.favourites": "Të parapëlqyer",
  "column.firehose": "Prurje “live”",
  "column.firehose_local": "Prurje “live” për këtë shërbyes",
  "column.firehose_singular": "Prurje “live”",
  "column.follow_requests": "Kërkesa për ndjekje",
  "column.home": "Kreu",
  "column.list_members": "Administroni anëtarë liste",
  "column.lists": "Lista",
  "column.mutes": "Përdorues të heshtuar",
  "column.notifications": "Njoftime",
  "column.other_collections": "Koleksione nga {name}",
  "column.pins": "Mesazhe të fiksuar",
  "column.public": "Rrjedhë kohore e të federuarave",
  "column.your_collections": "Koleksionet Tuaja",
  "column_back_button.label": "Mbrapsht",
  "column_header.hide_settings": "Fshihi rregullimet",
  "column_header.moveLeft_settings": "Shpjere shtyllën majtas",
  "column_header.moveRight_settings": "Shpjere shtyllën djathtas",
  "column_header.pin": "Fiksoje",
  "column_header.show_settings": "Shfaq rregullime",
  "column_header.unpin": "Shfiksoje",
  "column_search.cancel": "Anuloje",
  "combobox.close_results": "Mbylli përfundimet",
  "combobox.loading": "Po ngarkohet",
  "combobox.no_results_found": "S’ka përfundime për këtë kërkim",
  "combobox.open_results": "Hap përfundimet",
  "combobox.results_available": "Ka {count, plural, one {# sugjerim} other {# sugjerime}}. Që të lëvizni, përdorni tastet shigjetë poshtë dhe sipër. Që ta përzgjidhni, shtypni tastin Enter.",
  "community.column_settings.local_only": "Vetëm vendore",
  "community.column_settings.media_only": "Vetëm Media",
  "community.column_settings.remote_only": "Vetëm të largëta",
  "compose.error.blank_post": "Postimi s’mund të jetë i zbrazët.",
  "compose.language.change": "Ndryshoni gjuhën",
  "compose.language.search": "Kërkoni te gjuhët…",
  "compose.published.body": "Postimi u botua.",
  "compose.published.open": "Hape",
  "compose.saved.body": "Postimi u ruajt.",
  "compose_form.direct_message_warning_learn_more": "Mësoni më tepër",
  "compose_form.encryption_warning": "Postimet në Mastodon nuk fshehtëzohen skaj-më-skaj. Mos ndani me të tjerë gjëra me spec në Mastodon.",
  "compose_form.hashtag_warning": "Ky postim s’do të paraqitet nën ndonjë hashtag, ngaqë s’është publik. Vetëm postimet publike mund të kërkohen sipas hashtag-ësh.",
  "compose_form.lock_disclaimer": "Llogaria juaj s’është {locked}. Mund ta ndjekë cilido, për të parë postimet tuaja vetëm për ndjekësit.",
  "compose_form.lock_disclaimer.lock": "e kyçur",
  "compose_form.placeholder": "Ç’bluani në mendje?",
  "compose_form.poll.duration": "Kohëzgjatje pyetësori",
  "compose_form.poll.multiple": "Shumë zgjedhje",
  "compose_form.poll.option_placeholder": "Mundësia {number}",
  "compose_form.poll.single": "Zgjedhje njëshe",
  "compose_form.poll.switch_to_multiple": "Ndrysho votimin për të lejuar shumë zgjedhje",
  "compose_form.poll.switch_to_single": "Ndrysho votimin për të lejuar vetëm një zgjedhje",
  "compose_form.poll.type": "Stil",
  "compose_form.publish": "Postim",
  "compose_form.reply": "Përgjigjuni",
  "compose_form.save_changes": "Përditësoje",
  "compose_form.spoiler.marked": "Hiq sinjalizim lënde",
  "compose_form.spoiler.unmarked": "Shtoni sinjalizim lënde",
  "compose_form.spoiler_placeholder": "Sinjalizim lënde (opsional)",
  "confirmation_modal.cancel": "Anuloje",
  "confirmations.block.confirm": "Bllokoje",
  "confirmations.delete.confirm": "Fshije",
  "confirmations.delete.message": "Jeni i sigurt se doni të fshihet kjo gjendje?",
  "confirmations.delete.title": "Të fshihet postimi?",
  "confirmations.delete_collection.confirm": "Fshije",
  "confirmations.delete_collection.message": "Kjo llogari s’mund të zhbëhet.",
  "confirmations.delete_collection.title": "Të fshihet “{name}”?",
  "confirmations.delete_list.confirm": "Fshije",
  "confirmations.delete_list.message": "Jeni i sigurt se doni të fshihet përgjithmonë kjo listë?",
  "confirmations.delete_list.title": "Të fshihet lista?",
  "confirmations.discard_draft.confirm": "Hidhe tej dhe vazhdo",
  "confirmations.discard_draft.edit.cancel": "Rikthejuni përpunimit",
  "confirmations.discard_draft.edit.message": "Vazhdimi do të hedhë tej çfarëdo ndryshimesh që keni bërë te postimi që po përpunoni aktualisht.",
  "confirmations.discard_draft.edit.title": "Të hidhen tej ndryshimet te postimi juaj?",
  "confirmations.discard_draft.post.cancel": "Rikthejuni skicës",
  "confirmations.discard_draft.post.message": "Vazhdimi do të hedhë tej postimin që po hartoni aktualisht.",
  "confirmations.discard_draft.post.title": "Të hidhet tej skica e postimit tuaj?",
  "confirmations.discard_edit_media.confirm": "Hidhe tej",
  "confirmations.discard_edit_media.message": "Keni ndryshime të paruajtura te përshkrimi ose paraparja e medias, të hidhen tej, sido qoftë?",
  "confirmations.follow_to_list.confirm": "Ndiqe dhe shtoje te listë",
  "confirmations.follow_to_list.message": "Lypset të jeni duke e ndjekur {name}, që të shtohte te një listë.",
  "confirmations.follow_to_list.title": "Të ndiqet përdoruesi?",
  "confirmations.hide_featured_tab.confirm": "Fshihe skedën",
  "confirmations.hide_featured_tab.intro": "Mund ta ndryshoni kurdo këtë, që nga <i>Përpunoni profil > Rregullime skede profili</i>.",
  "confirmations.hide_featured_tab.message": "Kjo do ta fshehë skedën për përdorues në {serverName} dhe shërbyes të tjerë që xhirojnë versionin më të ri të Mastodon. Se si shfaqet te të tjera… varet.",
  "confirmations.hide_featured_tab.title": "Të fshihet skeda “Të zgjedhur”?",
  "confirmations.logout.confirm": "Dilni",
  "confirmations.logout.message": "Jeni i sigurt se doni të dilet?",
  "confirmations.logout.title": "Të dilet?",
  "confirmations.missing_alt_text.confirm": "Shtoni tekst alternativ",
  "confirmations.missing_alt_text.message": "Postimi juaj përmban media pa tekst alternativ. Shtimi i përshkrimeve ndihmon të bëhet lënda juaj e përdorshme nga më tepër njerëz.",
  "confirmations.missing_alt_text.secondary": "Postoje, sido qoftë",
  "confirmations.missing_alt_text.title": "Të shtohet tekst alternativ?",
  "confirmations.mute.confirm": "Heshtoje",
  "confirmations.private_quote_notify.cancel": "Mbrapsht te përpunimi",
  "confirmations.private_quote_notify.confirm": "Botoje postimin",
  "confirmations.private_quote_notify.do_not_show_again": "Mos ma shfaq prapë këtë mesazh",
  "confirmations.private_quote_notify.message": "Personi që citoni dhe përmendje të tjera do të njoftohen dhe do të jenë në gjendje të shohin postimin tuaj, edhe pse nuk ju ndjekin.",
  "confirmations.private_quote_notify.title": "T’u shfaqet ndjekësve dhe përdoruesve të përmendur?",
  "confirmations.quiet_post_quote_info.dismiss": "Mos ma kujto më",
  "confirmations.quiet_post_quote_info.got_it": "E mora vesh",
  "confirmations.quiet_post_quote_info.message": "Kur citoni një postim publik të heshtuar, postimi juaj do të kalohet i fshehur te rrjedha kohore e gjërave në modë.",
  "confirmations.quiet_post_quote_info.title": "Citim postimesh publikë të heshtuar",
  "confirmations.redraft.confirm": "Fshijeni & rihartojeni",
  "confirmations.redraft.message": "Jeni i sigurt se doni të fshihet kjo gjendje dhe të rihartohet? Të parapëlqyerit dhe përforcimet do të humbin, ndërsa përgjigjet te postimi origjinal do të bëhen jetime.",
  "confirmations.redraft.title": "Të fshihet & riharothet postimi?",
  "confirmations.remove_from_followers.confirm": "Hiqe ndjekësin",
  "confirmations.remove_from_followers.message": "{name} do të reshtë së ndjekuri ju. Jeni i sigurt se doni të vazhdohet?",
  "confirmations.remove_from_followers.title": "Të hiqet ndjekësi?",
  "confirmations.revoke_collection_inclusion.confirm": "Hiqmëni",
  "confirmations.revoke_collection_inclusion.message": "Ky veprim është i përhershëm dhe mirëmbajtësi s’do të jetë në gjendje t’ju rishtojë te koleksioni më vonë.",
  "confirmations.revoke_collection_inclusion.title": "Të hiqeni nga ky koleksion?",
  "confirmations.revoke_quote.confirm": "Hiqe postimin",
  "confirmations.revoke_quote.message": "Ky veprim s’mund të zhbëhet.",
  "confirmations.revoke_quote.title": "Të hiqet postimi?",
  "confirmations.unblock.confirm": "Zhbllokoje",
  "confirmations.unblock.title": "Të zhbllojohet {name}?",
  "confirmations.unfollow.confirm": "Resht së ndjekuri",
  "confirmations.unfollow.title": "Të ndalet ndjekja për {name}?",
  "confirmations.withdraw_request.confirm": "Tërhiqeni mbrapsht kërkesën",
  "confirmations.withdraw_request.title": "Të tërhiqet mbrapsht kërkesa për ndjeken e {name}?",
  "content_warning.hide": "Fshihe postimin",
  "content_warning.show": "Shfaqe, sido qoftë",
  "content_warning.show_more": "Shfaq më tepër",
  "content_warning.show_short": "Shfaqe",
  "conversation.delete": "Fshije bisedën",
  "conversation.mark_as_read": "Vëri shenjë si të lexuar",
  "conversation.open": "Shfaq bisedën",
  "conversation.with": "Me {names}",
  "copy_icon_button.copied": "U kopjua në të papastër",
  "copy_icon_button.copy_this_text": "Kopjoje lidhjen në të papastër",
  "copypaste.copied": "U kopjua",
  "copypaste.copy_to_clipboard": "Kopjoje në të papastër",
  "directory.federated": "Nga fedivers i njohur",
  "directory.local": "Vetëm nga {domain}",
  "directory.new_arrivals": "Të ardhur rishtas",
  "directory.recently_active": "Aktivë së fundi",
  "disabled_account_banner.account_settings": "Rregullime llogarie",
  "disabled_account_banner.text": "Llogaria juaj {disabledAccount} është aktualisht e çaktivizuar.",
  "dismissable_banner.community_timeline": "Këto janë postimet më të freskëta publike nga persona llogaritë e të cilëve strehohen nga {domain}.",
  "dismissable_banner.dismiss": "Hidhe tej",
  "dismissable_banner.public_timeline": "Këto janë postimet publike më të freskëta nga persona në fedivers që ndjekin personat në {domain}.",
  "domain_block_modal.block": "Bllokoje shërbyesin",
  "domain_block_modal.block_account_instead": "Blloko @{name} në vend të kësaj",
  "domain_block_modal.they_can_interact_with_old_posts": "Persona nga ky shërbyes mund të ndërveprojnë me postimet tuaja të vjetra.",
  "domain_block_modal.they_cant_follow": "S’mund t’ju ndjekë askush nga ky shërbyes.",
  "domain_block_modal.they_wont_know": "S’do ta dinë se janë bllokuar.",
  "domain_block_modal.title": "Të bllokohet përkatësia?",
  "domain_block_modal.you_will_lose_num_followers": "Do të humbni {followersCount, plural, one {{followersCountDisplay} ndjekës} other {{followersCountDisplay} ndjekës}} dhe {followingCount, plural, one {{followingCountDisplay} person që ndiqni} other {{followingCountDisplay} vetë që ndiqni}}.",
  "domain_block_modal.you_will_lose_relationships": "Do të humbni krejt ndjekësit dhe personat që ndiqni nga ky shërbyes.",
  "domain_block_modal.you_wont_see_posts": "S’do të shihni postime, apo njoftime nga përdorues në këtë shërbyes.",
  "domain_pill.activitypub_lets_connect": "Ju lejon të lidheni dhe ndërveproni me persona jo thjesht në Mastodon, por edhe nëpër aplikacione të ndryshme shoqërore.",
  "domain_pill.activitypub_like_language": "ActivityPub është si gjuha me të cilën Mastodon-i komunikon me rrjete të tjerë shoqërorë.",
  "domain_pill.server": "Shërbyes",
  "domain_pill.their_handle": "Targa e tij:",
  "domain_pill.their_server": "Shtëpia e tij dixhitale, ku rrinë krejt postimet prej tij.",
  "domain_pill.their_username": "Identifikuesi i tij unik në shërbyesin e vet. Është e mundur të gjenden përdorues me të njëjtin emër përdoruesi në shërbyes të ndryshëm.",
  "domain_pill.username": "Emër përdoruesi",
  "domain_pill.whats_in_a_handle": "Ç’është një targë?",
  "domain_pill.who_they_are": "Nga targat thonë se cili është dikush dhe se ku gjendet, ju mund të ndërveproni me persona nëpër web-in shoqëror të <button>platformave të ngritura mbi ActivityPub</button>.",
  "domain_pill.who_you_are": "Ngaqë targa juaj thotë se cili jeni dhe se ku gjendeni, njerëzit mund të ndërveprojnë me ju nëpër web-in shoqëror të <button>platformave të bazuara në ActivityPub</button>.",
  "domain_pill.your_handle": "Targa juaj:",
  "domain_pill.your_server": "Shtëpia juaj dixhitale, kur gjenden krejt postimet tuaja. S’ju pëlqen kjo këtu? Shpërngulni shërbyes kur të doni dhe sillni edhe ndjekësit tuaj.",
  "domain_pill.your_username": "Identifikuesi juja unik në këtë shërbyes. Është e mundur të gjenden përdorues me të njëjtin emër përdoruesi në shërbyes të ndryshëm.",
  "dropdown.empty": "Përzgjidhni një mundësi",
  "email_subscriptions.email": "Email",
  "email_subscriptions.form.action": "Pajtohuni",
  "email_subscriptions.form.bottom": "Merrni postime në email-in tuaj, pa krijuar një llogari Mastodon. Shpajtohuni në çfarëdo kohe. Për më tepër informacion, shihni te <a>Rregulla Privatësie</a>.",
  "email_subscriptions.form.title": "Regjistrohuni për përditësime me email nga {name}",
  "email_subscriptions.submitted.lead": "Shihni te mesazhet tuaj të marrë për një email, që të përfundoni regjistrimin për përditësime me email.",
  "email_subscriptions.submitted.title": "Edhe një hap",
  "email_subscriptions.validation.email.blocked": "Shërbim email i bllokuar",
  "email_subscriptions.validation.email.invalid": "Adresë email e pavlefshme",
  "embed.instructions": "Trupëzojeni këtë gjendje në sajtin tuaj duke kopjuar kodin më poshtë.",
  "embed.preview": "Ja si do të duket:",
  "emoji_button.activity": "Veprimtari",
  "emoji_button.clear": "Spastroje",
  "emoji_button.custom": "Vetjak",
  "emoji_button.flags": "Flamuj",
  "emoji_button.food": "Ushqim & Pije",
  "emoji_button.label": "Futni emoxhi",
  "emoji_button.nature": "Natyrë",
  "emoji_button.not_found": "No emojos!!! (╯°□°）╯︵ ┻━┻",
  "emoji_button.objects": "Objekte",
  "emoji_button.people": "Persona",
  "emoji_button.recent": "Të përdorur shpesh",
  "emoji_button.search": "Kërkoni…",
  "emoji_button.search_results": "Përfundime kërkimi",
  "emoji_button.symbols": "Simbole",
  "emoji_button.travel": "Udhëtime & Vende",
  "empty_column.account_featured.other": "{acct} s’ka ende ndonjë gjë të zgjedhur.",
  "empty_column.account_featured_self.no_collections_button": "Krijoni një koleksion",
  "empty_column.account_featured_self.no_collections_hide_tab": "Fshihe këtë skedë, më mirë",
  "empty_column.account_featured_self.pre_collections": "Ndiqeni për Koleksione",
  "empty_column.account_featured_self.pre_collections_desc": "Koleksionet (që vijnë me Mastodon 4.6) ju lejojnë të krijoni lista tuajat llogarish për t’ua rekomanduar të tjerëve.",
  "empty_column.account_featured_self.showcase_accounts": "Shpalosni llogaritë tuaja të parapëlqyera",
  "empty_column.account_featured_self.showcase_accounts_desc": "Koleksionet janë lista llogarish për të ndihmuar të tjerët të zbulojnë më tepër gjëra në Fedivers.",
  "empty_column.account_featured_unknown.other": "Kjo llogari s’ka zgjedhur gjë ende.",
  "empty_column.account_hides_collections": "Ky përdorues ka zgjedhur të mos e japë këtë informacion",
  "empty_column.account_suspended": "Llogaria u pezullua",
  "empty_column.account_timeline": "S’ka mesazhe këtu!",
  "empty_column.account_unavailable": "Profil jashtë funksionimi",
  "empty_column.blocks": "S’keni bllokuar ende ndonjë përdorues.",
  "empty_column.bookmarked_statuses": "S’keni faqeruajtur ende ndonjë mesazh. Kur faqeruani një të tillë, ai do të shfaqet këtu.",
  "empty_column.collections.featured_in": "S’jeni shtuar ende te ndonjë koleksion.",
  "empty_column.community": "Rrjedha kohore vendore është e zbrazët. Shkruani diçka publikisht që t’i hyhet valles!",
  "empty_column.direct": "S’keni ende ndonjë përmendje private. Kur dërgoni ose merrni një të tillë, do të shfaqet këtu.",
  "empty_column.disabled_feed": "Kjo prurje është çaktivizuar nga përgjegjësit e  shërbyesit tuaj.",
  "empty_column.domain_blocks": "Ende s’ka përkatësi të fshehura.",
  "empty_column.explore_statuses": "Asgjë në modë tani. Kontrolloni më vonë!",
  "empty_column.favourited_statuses": "S’keni ende ndonjë postim të parapëlqyer. Kur të parapëlqeni një të tillë, do të shfaqet këtu.",
  "empty_column.favourites": "Ky postim s’është i parapëlqyer ende për ndokënd. Kur dikush e kalon të parapëlqyer, do të shfaqet këtu.",
  "empty_column.follow_requests": "Ende s’keni ndonjë kërkesë ndjekjeje. Kur të merrni një të tillë, do të shfaqet këtu.",
  "empty_column.followed_tags": "S’keni ndjekur ende nodnjë hashtag. Kur të ndiqni të tillë, do të shfaqen këtu.",
  "empty_column.hashtag": "Ende s’ka gjë nën këtë hashtag.",
  "empty_column.home": "Rrjedha juaj kohore është e zbrazët! Vizitoni {public} ose përdorni kërkimin që t’ia filloni dhe të takoni përdorues të tjerë.",
  "empty_column.list": "Në këtë listë ende s’ka gjë. Kur anëtarë të kësaj liste postojnë gjendje të reja, ato do të shfaqen këtu.",
  "empty_column.mutes": "S’keni heshtuar ende ndonjë përdorues.",
  "empty_column.notification_requests": "Gjithçka si duhet! S’ka ç’bëhet këtu. Kur merrni njoftime të reja, do të shfaqen këtu, në përputhje me rregullimet tuaja.",
  "empty_column.notifications": "Ende s’keni ndonjë njoftim. Ndërveproni me të tjerët që të nisë biseda.",
  "empty_column.public": "S’ka gjë këtu! Shkruani diçka publikisht, ose ndiqni dorazi përdorues prej instancash të tjera, që kjo të mbushet",
  "empty_state.no_results": "S’ka përfundime",
  "error.no_hashtag_feed_access": "Që të shihni dhe ndiqni hashtag-ë, regjistrohuni, ose bëni hyrjen.",
  "error.unexpected_crash.explanation": "Për shkak të një të mete në kodin tonë ose të një problemi përputhshmërie të shfletuesit, kjo faqe s’mund të shfaqet saktë.",
  "error.unexpected_crash.explanation_addons": "Kjo faqe s’u shfaq dot saktë. Ky gabim ka gjasa të jetë shkaktuar nga një shtesë shfletuesi ose një mjet përkthimi të automatizuar.",
  "error.unexpected_crash.next_steps": "Provoni të freskoni faqen. Nëse kjo s’bën punë, mundeni ende të jeni në gjendje të përdorni Mastodon-in që nga një shfletues tjetër ose nga ndonjë aplikacion origjinal prej projektit.",
  "error.unexpected_crash.next_steps_addons": "Provoni t’i çaktivizoni dhe të rifreskoni faqen. Nëse kjo s’bën punë, mundeni prapë të jeni në gjendje të përdorni Mastodon-in përmes një shfletuesi tjetër, apo një aplikacioni prej Mastodon-it.",
  "errors.unexpected_crash.copy_stacktrace": "Kopjo stacktrace-in në të papastër",
  "errors.unexpected_crash.report_issue": "Raportoni problemin",
  "explore.suggested_follows": "Persona",
  "explore.title": "Në modë",
  "explore.trending_links": "Lajme",
  "explore.trending_statuses": "Postime",
  "explore.trending_tags": "Hashtagë",
  "featured_carousel.current": "<sr>Postimi</sr> {current, number} / {max, number}",
  "featured_carousel.header": "{count, plural, one {Postim i Fiksuar} other {Postime të Fiksuar}}",
  "featured_carousel.slide": "Postimi {current, number} nga {max, number} gjithsej",
  "featured_tags.more_items": "+{count}",
  "featured_tags.suggestions": "Tani së fundi keni postuar rreth {items}. Të shtohen këto si hashtag-ë të zgjedhur?",
  "featured_tags.suggestions.add": "Shtoji",
  "featured_tags.suggestions.added": "Administroni kurdo hashtag-ët tuaj të zgjedhur, nën <link>Përpunoni Profil > Hashtag-ë të zgjedhur</link>.",
  "featured_tags.suggestions.dismiss": "Jo, faleminderit",
  "filter_modal.added.context_mismatch_explanation": "Kjo kategori filtrash nuk aplikohet për kontekstin nën të cilin po merreni me këtë postim. Nëse doni që postimi të filtrohet edhe në këtë kontekst, do t’ju duhet të përpunoni filtrin.",
  "filter_modal.added.context_mismatch_title": "Mospërputhje kontekstesh!",
  "filter_modal.added.expired_explanation": "Kjo kategori filtrash ka skaduar, do t’ju duhet të ndryshoni datën e skadimit për të, pa të aplikohet.",
  "filter_modal.added.expired_title": "Filtër i skaduar!",
  "filter_modal.added.review_and_configure": "Që të shqyrtoni dhe formësoni më tej këtë kategori filtrash, kaloni te {settings_link}.",
  "filter_modal.added.review_and_configure_title": "Rregullime filtrash",
  "filter_modal.added.settings_link": "faqe rregullimesh",
  "filter_modal.added.short_explanation": "Ky postim është shtuar te kategoria vijuese e filtrave: {title}.",
  "filter_modal.added.title": "U shtua filtër!",
  "filter_modal.select_filter.context_mismatch": "mos e apliko mbi këtë kontekst",
  "filter_modal.select_filter.expired": "ka skaduar",
  "filter_modal.select_filter.prompt_new": "Kategori e re: {name}",
  "filter_modal.select_filter.search": "Kërkoni, ose krijoni",
  "filter_modal.select_filter.subtitle": "Përdorni një kategori ekzistuese, ose krijoni një të re",
  "filter_modal.select_filter.title": "Filtroje këtë postim",
  "filter_modal.title.status": "Filtroni një postim",
  "filter_warning.matches_filter": "Ka përkim me filtrin “<span>{title}</span>”",
  "filtered_notifications_banner.pending_requests": "Nga {count, plural, =0 {askush} one {një person} other {# vetë}} që mund të njihni",
  "filtered_notifications_banner.title": "Njoftime të filtruar",
  "firehose.all": "Krejt",
  "firehose.local": "Këtë shërbyes",
  "firehose.remote": "Shërbyes të tjerë",
  "follow_request.authorize": "Autorizoje",
  "follow_request.reject": "Hidhe tej",
  "follow_requests.unlocked_explanation": "Edhe pse llogaria juaj s’është e kyçur, ekipi i {domain} mendoi se mund të donit të shqyrtonit dorazi kërkesa ndjekjeje prej këtyre llogarive.",
  "follow_suggestions.curated_suggestion": "Zgjedhur nga ekipi",
  "follow_suggestions.dismiss": "Mos shfaq më",
  "follow_suggestions.featured_longer": "Zgjedhur enkas nga ekipi {domain}",
  "follow_suggestions.friends_of_friends_longer": "Popullore mes personash që ndiqni",
  "follow_suggestions.hints.featured": "Ky profil është zgjedhur nga ekipi {domain}.",
  "follow_suggestions.hints.friends_of_friends": "Ky profil është popullor mes personave që ndiqni.",
  "follow_suggestions.hints.most_followed": "Ky profil është një nga më të ndjekur në {domain}.",
  "follow_suggestions.hints.most_interactions": "Ky profil ka tërhequr mjaft vëmendjen së fundi në {domain}.",
  "follow_suggestions.hints.similar_to_recently_followed": "Ky profil është i ngjashëm me profile që keni ndjekur tani afër.",
  "follow_suggestions.personalized_suggestion": "Sugjerim i personalizuar",
  "follow_suggestions.popular_suggestion": "Sugjerim popullor",
  "follow_suggestions.popular_suggestion_longer": "Popullore në {domain}",
  "follow_suggestions.similar_to_recently_followed_longer": "I ngjashëm me profile që keni zënë të ndiqni së fundi",
  "follow_suggestions.view_all": "Shihni krejt",
  "follow_suggestions.who_to_follow": "Cilët të ndiqen",
  "followed_tags": "Hashtag-ë të ndjekur",
  "followers.hide_other_followers": "Ky përdorues ka zgjedhur të mos i bëjë të dukshëm ndjekësit e vet të tjerë",
  "followers.title": "Ndjekje e {name}",
  "following.hide_other_following": "Ky përdorues ka zgjedhur të mos bëjë të dukshëm pjesën tjetër të përdoruesve që ndjek",
  "following.title": "Ndjekur nga {name}",
  "footer.about": "Mbi",
  "footer.about_mastodon": "Mbi Mastodon-in",
  "footer.about_server": "Mbi {domain}",
  "footer.about_this_server": "Mbi",
  "footer.directory": "Drejtori profilesh",
  "footer.get_app": "Merreni aplikacionin",
  "footer.keyboard_shortcuts": "Shkurtore tastiere",
  "footer.privacy_policy": "Rregulla privatësie",
  "footer.source_code": "Shihni kodin burim",
  "footer.status": "Gjendje",
  "footer.terms_of_service": "Kushte shërbimi",
  "form_error.blank": "Fusha s’mund të jetë e zbrazët.",
  "form_field.optional": "(opsionale)",
  "generic.saved": "U ruajt",
  "getting_started.heading": "Si t’ia fillohet",
  "hashtag.admin_moderation": "Hap ndërfaqe moderimi për #{name}",
  "hashtag.browse": "Shfletoni postime me #{hashtag}",
  "hashtag.browse_from_account": "Shfletoni postime nga @{name} me #{hashtag}",
  "hashtag.column_header.tag_mode.all": "dhe {additional}",
  "hashtag.column_header.tag_mode.any": "ose {additional}",
  "hashtag.column_header.tag_mode.none": "pa {additional}",
  "hashtag.column_settings.select.no_options_message": "S’u gjetën sugjerime",
  "hashtag.column_settings.select.placeholder": "Jepni hashtag-ë…",
  "hashtag.column_settings.tag_mode.all": "Krejt këta",
  "hashtag.column_settings.tag_mode.any": "Cilindo prej këtyre",
  "hashtag.column_settings.tag_mode.none": "Asnjë prej këtyre",
  "hashtag.column_settings.tag_toggle": "Përfshi etiketa shtesë për këtë shtyllë",
  "hashtag.counter_by_accounts": "{count, plural, one {{counter} pjesëmarrës} other {{counter} pjesëmarrës}}",
  "hashtag.counter_by_uses": "{count, plural, one {{counter} postim} other {{counter} postime}}",
  "hashtag.counter_by_uses_today": "{count, plural, one {{counter} postim} other {{counter} postime}} sot",
  "hashtag.feature": "Pasqyrojeni në profil",
  "hashtag.follow": "Ndiqe hashtag-un",
  "hashtag.mute": "Heshtoje #{hashtag}",
  "hashtag.unfeature": "Mos e përfshi në profil",
  "hashtag.unfollow": "Hiqe ndjekjen e hashtag-ut",
  "hashtags.and_other": "…dhe {count, plural, one {}other {# më tepër}}",
  "hints.profiles.followers_may_be_missing": "Mund të mungojnë ndjekës për këtë profil.",
  "hints.profiles.follows_may_be_missing": "Mund të mungojnë ndjekje për këtë profil.",
  "hints.profiles.posts_may_be_missing": "Mund të mungojnë disa postime prej këtij profili.",
  "hints.profiles.see_more_followers": "Shihni më tepër ndjekës në {domain}",
  "hints.profiles.see_more_follows": "Shihni më tepër ndjekje në {domain}",
  "hints.profiles.see_more_posts": "Shihni më tepër postime në {domain}",
  "home.column_settings.show_quotes": "Shfaq thonjëza",
  "home.column_settings.show_reblogs": "Shfaq përforcime",
  "home.column_settings.show_replies": "Shfaq përgjigje",
  "home.hide_announcements": "Fshihi lajmërimet",
  "home.pending_critical_update.body": "Ju lutemi, përditësoni sa më shpejt të jetë e mundur shërbyesin tuaj Mastodon!",
  "home.pending_critical_update.link": "Shihni përditësime",
  "home.pending_critical_update.title": "Ka përditësim kritik të lidhur me sigurinë!",
  "home.show_announcements": "Shfaqi lajmërimet",
  "ignore_notifications_modal.disclaimer": "Mastodon-i s’mund të njoftojë përdoruesit se po shpërfillni njoftimet e tyre. Shpërfillja e njoftimeve s’do të ndalë dërgimin e vetë mesazheve.",
  "ignore_notifications_modal.filter_instead": "Në vend të kësaj, filtroji",
  "ignore_notifications_modal.filter_to_act_users": "Do të jeni prapë në gjendje të pranoni, hidhni poshtë, ose raportoni përdorues",
  "ignore_notifications_modal.filter_to_avoid_confusion": "Filtrimi ndihmon të shmanget konfuzion potencial",
  "ignore_notifications_modal.filter_to_review_separately": "Njoftimet e filtruara mund t’i shqyrtoni ndarazi",
  "ignore_notifications_modal.ignore": "Shpërfilli njoftimet",
  "ignore_notifications_modal.limited_accounts_title": "Të shpërfillen njoftime nga llogari të moderuara?",
  "ignore_notifications_modal.new_accounts_title": "Të shpërfillen njoftime nga llogari të reja?",
  "ignore_notifications_modal.not_followers_title": "Të shpërfillen njoftime nga persona që s’ju ndjekin?",
  "ignore_notifications_modal.not_following_title": "Të shpërfillen njoftime nga persona që s’i ndiqni?",
  "ignore_notifications_modal.private_mentions_title": "Të shpërfillen njoftime nga Përmendje Private të pakërkuara?",
  "info_button.label": "Ndihmë",
  "info_button.what_is_alt_text": "<h1>Ç’është teksti alternativ?</h1> <p>Teksti alternativ jep përshkrime figurash për persona me mangësi në të parët, lidhje me gjerësi bande të ulët, ose për ata që duan kontekst shtesë.</p> <p>Mund të përmirësoni përdorimin nga persona me aftësi të kufizuara dhe kuptimin për këto, duke shkruar tekst alternativ të qartë, konciz dhe objektiv.</p> <ul> <li>Rrokni elementët e rëndësishëm</li> <li>Përmblidhni tekst në figura</li> <li>Përdorni strukturë të rregullt fjalish</li> <li>Shmangni përsëritje informacioni</li> <li>Në aspekte pamore të ndërlikuara (fjala vjen, diagrame ose harta) përqendrohuni te prirje dhe gjetje gjërash kyçe</li> </ul>",
  "interaction_modal.action": "Që të ndërveproni me postimin nga {name}, lypset të bëni hyrjen në llogarinë tuaj, ose në çfarëdo shërbyesi Mastodon që përdorni.",
  "interaction_modal.action_follow": "Që të ndiqni {name}, lypset të bëni hyrjen te llogaria juaj në cilindo shërbyes Mastodon që përdorni.",
  "interaction_modal.go": "Shko",
  "interaction_modal.no_account_yet": "S’keni ende një llogari?",
  "interaction_modal.on_another_server": "Në një tjetër shërbyes",
  "interaction_modal.on_this_server": "Në këtë shërbyes",
  "interaction_modal.title": "Që të vazhdohet, bëni hyrjen",
  "interaction_modal.username_prompt": "P.sh., {example}",
  "intervals.full.days": "{number, plural, one {# ditë} other {# ditë}}",
  "intervals.full.hours": "{number, plural, one {# orë} other {# orë}}",
  "intervals.full.minutes": "{number, plural, one {# minutë} other {# minuta}}",
  "keyboard_shortcuts.back": "Për shkuarje mbrapsht",
  "keyboard_shortcuts.blocked": "Për hapje liste përdoruesish të bllokuar",
  "keyboard_shortcuts.boost": "Përforcim postimi",
  "keyboard_shortcuts.column": "Fokusi mbi një shtyllë",
  "keyboard_shortcuts.compose": "Fokusi te fusha e hartimit të mesazheve",
  "keyboard_shortcuts.description": "Përshkrim",
  "keyboard_shortcuts.direct": "Hap shtyllë përmendjesh private",
  "keyboard_shortcuts.down": "Për zbritje poshtë nëpër listë",
  "keyboard_shortcuts.enter": "Për hapje postimi",
  "keyboard_shortcuts.explore": "Hap rrjedhë kohore të gjërave në modë",
  "keyboard_shortcuts.favourite": "I vini shenjë postimit si të parapëlqyer",
  "keyboard_shortcuts.favourites": "Hapni listë të parapëlqyerish",
  "keyboard_shortcuts.federated": "Për hapje rrjedhe kohore të të federuarave",
  "keyboard_shortcuts.heading": "Shkurtore tastiere",
  "keyboard_shortcuts.home": "Për hapje rrjedhe kohore vetjake",
  "keyboard_shortcuts.hotkey": "Tast përkatës",
  "keyboard_shortcuts.legend": "Për shfaqje të kësaj legjende",
  "keyboard_shortcuts.load_more": "Kaloje fokusin te butoni “Ngarko më tepër”",
  "keyboard_shortcuts.local": "Për hapje rrjedhe kohore vendore",
  "keyboard_shortcuts.mention": "Për përmendje të autorit",
  "keyboard_shortcuts.muted": "Për hapje liste përdoruesish të heshtuar",
  "keyboard_shortcuts.my_profile": "Për hapjen e profilit tuaj",
  "keyboard_shortcuts.notifications": "Për hapje shtylle njoftimesh",
  "keyboard_shortcuts.open_media": "Për hapje mediash",
  "keyboard_shortcuts.pinned": "Për hapje liste mesazhesh të fiksuar",
  "keyboard_shortcuts.profile": "Për hapje të profilit të autorit",
  "keyboard_shortcuts.quote": "Citoni postim",
  "keyboard_shortcuts.reply": "Për t’iu përgjigjur një postimi",
  "keyboard_shortcuts.requests": "Për hapje liste kërkesash për ndjekje",
  "keyboard_shortcuts.search": "Për kalim fokusi te kërkimi",
  "keyboard_shortcuts.spoilers": "Për shfaqje/fshehje fushe CW",
  "keyboard_shortcuts.start": "Për hapjen e shtyllës “fillojani”",
  "keyboard_shortcuts.toggle_hidden": "Për shfaqje/fshehje teksti pas CW",
  "keyboard_shortcuts.toggle_sensitivity": "Për shfaqje/fshehje mediash",
  "keyboard_shortcuts.toot": "Për të filluar një mesazh të ri",
  "keyboard_shortcuts.top": "Shpjere në krye të listës",
  "keyboard_shortcuts.translate": "për të përkthyer një postim",
  "keyboard_shortcuts.unfocus": "Për heqjen e fokusit nga fusha e hartimit të mesazheve apo kërkimeve",
  "keyboard_shortcuts.up": "Për ngjitje sipër nëpër listë",
  "learn_more_link.got_it": "E mora vesh",
  "learn_more_link.learn_more": "Mësoni më tepër",
  "lightbox.close": "Mbylle",
  "lightbox.next": "Pasuesja",
  "lightbox.previous": "E mëparshmja",
  "lightbox.zoom_in": "Ktheje në madhësinë origjinale",
  "lightbox.zoom_out": "Zmadhoje të përshtatet",
  "limited_account_hint.action": "Shfaqe profilin sido qoftë",
  "limited_account_hint.title": "Ky profil është fshehur nga moderatorët e {domain}.",
  "link_preview.author": "Nga {name}",
  "link_preview.more_from_author": "Më tepër nga {name}",
  "link_preview.shares": "{count, plural, one {{counter} post} other {{counter} postime}}",
  "lists.add_member": "Shtoje",
  "lists.add_to_list": "Shto në listë",
  "lists.add_to_lists": "Shtoje {name} në lista",
  "lists.create": "Krijoje",
  "lists.create_a_list_to_organize": "Krijoni një listë të re të sistemoni prurjen tuaj Kreu",
  "lists.create_list": "Krijo listë",
  "lists.delete": "Fshije listën",
  "lists.done": "U bë",
  "lists.edit": "Përpunoni listën",
  "lists.exclusive": "Fshihni anëtarët në Krye",
  "lists.exclusive_hint": "Nëse dikush gjendje në këtë listë, fshihini ata te prurja juaj e Kreut, që të shmangni parjen dy herë të postimeve të tyre.",
  "lists.find_users_to_add": "Gjeni përdorues për t’i shtuar",
  "lists.list_members_count": "{count, plural, one {# anëtar} other {# anëtarë}}",
  "lists.list_name": "Emër liste",
  "lists.new_list_name": "Emër liste të re",
  "lists.no_lists_yet": "Ende pa lista.",
  "lists.no_members_yet": "Ende pa anëtarë.",
  "lists.no_results_found": "S’u gjetën përfundime.",
  "lists.remove_member": "Hiqe",
  "lists.replies_policy.followed": "Cilido përdorues i ndjekur",
  "lists.replies_policy.list": "Anëtarë të listës",
  "lists.replies_policy.none": "Askush",
  "lists.save": "Ruaje",
  "lists.search": "Kërko",
  "lists.show_replies_to": "Përfshi përgjigje nga anëtarë liste te",
  "load_pending": "{count, plural,one {# objekt i ri }other {# objekte të rinj }}",
  "loading_indicator.label": "Po ngarkohet…",
  "media_gallery.hide": "Fshihe",
  "moved_to_account_banner.text": "Llogaria juaj {disabledAccount} aktualisht është e çaktivizuar, ngaqë kaluat te {movedToAccount}.",
  "mute_modal.hide_from_notifications": "Fshihe prej njoftimeve",
  "mute_modal.hide_options": "Fshihi mundësitë",
  "mute_modal.indefinite": "Deri sa t’u heq heshtimin",
  "mute_modal.show_options": "Shfaq mundësi",
  "mute_modal.they_can_mention_and_follow": "Mund t’ju përmendin dhe ndjekin, por s’do t’i shihni.",
  "mute_modal.they_wont_know": "S’do ta dinë se janë heshtuar.",
  "mute_modal.title": "Të heshtohet përdoruesi?",
  "mute_modal.you_wont_see_mentions": "S’do të shihni postime ku përmenden.",
  "mute_modal.you_wont_see_posts": "Ata munden ende të shohin postimet tuaja, por ju s’do të shihni të tyret.",
  "navigation_bar.about": "Mbi",
  "navigation_bar.account_settings": "Fjalëkalim dhe siguri",
  "navigation_bar.administration": "Administrim",
  "navigation_bar.advanced_interface": "Hape në ndërfaqe web të thelluar",
  "navigation_bar.automated_deletion": "Fshirje e automatizuar postimesh",
  "navigation_bar.blocks": "Përdorues të bllokuar",
  "navigation_bar.bookmarks": "Faqerojtës",
  "navigation_bar.collections": "Koleksione",
  "navigation_bar.direct": "Përmendje private",
  "navigation_bar.domain_blocks": "Përkatësi të bllokuara",
  "navigation_bar.favourites": "Të parapëlqyer",
  "navigation_bar.filters": "Fjalë të heshtuara",
  "navigation_bar.follow_requests": "Kërkesa për ndjekje",
  "navigation_bar.followed_tags": "Hashtag-ë të ndjekur",
  "navigation_bar.follows_and_followers": "Ndjekje dhe ndjekës",
  "navigation_bar.import_export": "Importim dhe eksportim",
  "navigation_bar.lists": "Lista",
  "navigation_bar.live_feed_local": "Pryrje e atypëratyshme (vendore)",
  "navigation_bar.live_feed_public": "Prurje e atypëratyshme (publike)",
  "navigation_bar.logout": "Dalje",
  "navigation_bar.moderation": "Moderim",
  "navigation_bar.more": "Më tepër",
  "navigation_bar.mutes": "Përdorues të heshtuar",
  "navigation_bar.opened_in_classic_interface": "Postime, llogari dhe të tjera faqe specifike, si parazgjedhje, hapen në ndërfaqe klasike web.",
  "navigation_bar.preferences": "Parapëlqime",
  "navigation_bar.privacy_and_reach": "Privatësi dhe shtrirje",
  "navigation_bar.search": "Kërkoni",
  "navigation_bar.search_trends": "Kërkim / Në modë",
  "navigation_panel.collapse_followed_tags": "Tkurre menunë e hashtag-ëve të ndjekur",
  "navigation_panel.collapse_lists": "Palose menunë listë",
  "navigation_panel.expand_followed_tags": "Zgjeroje menunë e hashtag-ëve të ndjekur",
  "navigation_panel.expand_lists": "Hape menunë listë",
  "not_signed_in_indicator.not_signed_in": "Që të përdorni këtë burim, lypset të bëni hyrjen.",
  "notification.added_to_collection": "{name} ju shtoi në koleksion",
  "notification.admin.report": "{name} raportoi {target}",
  "notification.admin.report_account": "{name} raportoi për {count, plural, one {një postim} other {# postime}} nga {target} për {category}",
  "notification.admin.report_account_other": "{name} raportoi për {count, plural, one {një postim} other {# postime}} nga {target}",
  "notification.admin.report_statuses": "{name} raportoi {target} për {category}",
  "notification.admin.report_statuses_other": "{name} raportoi {target}",
  "notification.admin.sign_up": "{name} u regjistrua",
  "notification.admin.sign_up.name_and_others": "U regjistrua {name} dhe {count, plural, one {# tjetër} other {# të tjerë}}",
  "notification.annual_report.message": "#Wrapstodon juaj për {year} pret! Zbuloni pikat e theksuara dhe çastet e paharrueshëm të këtij viti për ju në Mastodon!",
  "notification.annual_report.view": "Shihni #Wrapstodon",
  "notification.collection_update": "{name} përpunoi një koleksion në të cilin gjendeni",
  "notification.favourite": "{name} i vuri shenjë postimit tuaj si të parapëlqyer",
  "notification.favourite.name_and_others_with_link": "{name} dhe <a>{count, plural, one {# tjetër} other {# të tjerë}}</a> i vunë shenjë postimit tuaj si të parapëlqyer",
  "notification.favourite_pm": "{name} i vuri shenjë si të parapëlqyer përmendjes tuaj private",
  "notification.favourite_pm.name_and_others_with_link": "{name} dhe <a>{count, plural, one {# tjetër} other {# të tjerë}}</a> i vunë shenjë si të parapëlqyer përmendjes tuaj private",
  "notification.follow": "{name} zuri t’ju ndjekë",
  "notification.follow.name_and_others": "Ju ndoqi {name} dhe <a>{count, plural, one {# tjetër} other {# të tjerë}}</a>",
  "notification.follow_request": "{name} ka kërkuar t’ju ndjekë",
  "notification.follow_request.name_and_others": "Ka kërkuar t’ju ndjekë {name} dhe {count, plural, one {# tjetër} other {# të tjerë}}",
  "notification.label.mention": "Përmendje",
  "notification.label.private_mention": "Përmendje private",
  "notification.label.private_reply": "Përgjigje private",
  "notification.label.quote": "{name} citoi postimin tuaj",
  "notification.label.reply": "Përgjigje",
  "notification.mention": "Përmendje",
  "notification.mentioned_you": "{name} ju ka përmendur",
  "notification.moderation-warning.learn_more": "Mësoni më tepër",
  "notification.moderation_warning": "Ju është dhënë një sinjalizim moderimi",
  "notification.moderation_warning.action_delete_statuses": "Disa nga postimet tuaja janë hequr.",
  "notification.moderation_warning.action_disable": "Llogaria juaj është çaktivizuar.",
  "notification.moderation_warning.action_mark_statuses_as_sensitive": "Disa prej postimeve tuaja u është vënë shenjë si me spec.",
  "notification.moderation_warning.action_none": "Llogaria juaj ka marrë një sinjalizim moderimi.",
  "notification.moderation_warning.action_sensitive": "Postimeve tuaja do t’u vihet shenjë si me spec, nga tani e tutje.",
  "notification.moderation_warning.action_silence": "Llogaria juaj është kufizuar.",
  "notification.moderation_warning.action_suspend": "Llogaria juaj është pezulluar.",
  "notification.own_poll": "Pyetësori juaj ka përfunduar",
  "notification.poll": "Ka përfunduar një pyetësor në të cilin keni marrë pjesë",
  "notification.quoted_update": "{name} përpunoi një postim që keni cituar",
  "notification.reblog": "{name} përforcoi mesazhin tuaj",
  "notification.reblog.name_and_others_with_link": "Ju ka përforcuar {name} dhe <a>{count, plural, one {# tjetër} other {# të tjerë}}</a>",
  "notification.relationships_severance_event": "Lidhje të humbura me {name}",
  "notification.relationships_severance_event.account_suspension": "Një përgjegjës nga {from} ka pezulluar {target}, që do të thotë se s’mund të merrni më përditësime prej tij, apo të ndërveproni me të.",
  "notification.relationships_severance_event.domain_block": "Një përgjegjës nga {from} ka bllokuar {target}, përfshi {followersCount} të ndjekësve tuaj dhe {followingCount, plural, one {# llogari} other {# llogari}} që ndiqni.",
  "notification.relationships_severance_event.learn_more": "Mësoni më tepër",
  "notification.relationships_severance_event.user_domain_block": "Keni bllokuar {target}, duke hequr {followersCount} nga ndjekësit tuaj dhe {followingCount, plural, one {# llogari} other {# llogari}} që ndiqni.",
  "notification.status": "{name} sapo postoi",
  "notification.update": "{name} përpunoi një postim",
  "notification_requests.accept": "Pranoje",
  "notification_requests.accept_multiple": "{count, plural, one {Pranoni # kërkesë…} other {Pranoni # kërkesa…}}",
  "notification_requests.confirm_accept_multiple.button": "{count, plural, one {Pranojeni kërkesën} other {Pranoje kërkesën}}",
  "notification_requests.confirm_accept_multiple.message": "Ju ndan një hap nga pranimi i {count, plural, one {një kërkese njoftimi} other {# kërkesash njoftimi}}. Jeni i sigurt se doni të vazhdohet?",
  "notification_requests.confirm_accept_multiple.title": "Të pranohen kërkesa njoftimesh?",
  "notification_requests.confirm_dismiss_multiple.button": "{count, plural, one {Hidheni tej kërkesën} other {Hidhini tej kërkesat}}",
  "notification_requests.confirm_dismiss_multiple.message": "Ju ndan një hap nga hedhja tej e {count, plural, one {një kërkese njoftimesh} other {# kërkesash njoftimesh}}. S’do të jeni në gjendje të shihni sërish {count, plural, one {atë} other {ato}}. Jeni i sigurt se doni të bëhet kjo?",
  "notification_requests.confirm_dismiss_multiple.title": "Të hidhen tej kërkesa njoftimesh?",
  "notification_requests.dismiss": "Hidhe tej",
  "notification_requests.dismiss_multiple": "{count, plural, one {Hidhni tej # kërkesë…} other {Hidhni tej # kërkesa…}}",
  "notification_requests.edit_selection": "Përpunoni",
  "notification_requests.exit_selection": "U bë",
  "notification_requests.explainer_for_limited_account": "Njoftimet prej kësaj llogarie janë filtruar, ngaqë llogaria është kufizuar nga një moderator.",
  "notification_requests.explainer_for_limited_remote_account": "Njoftimet prej kësaj llogarie janë filtruar, ngaqë llogaria, ose shërbyesi është kufizuar nga një moderator.",
  "notification_requests.maximize": "Maksimizoje",
  "notification_requests.minimize_banner": "Minimizo banderolë njoftimesh të filtruara",
  "notification_requests.notifications_from": "Njoftime prej {name}",
  "notification_requests.title": "Njoftime të filtruar",
  "notification_requests.view": "Shihni njoftime",
  "notifications.clear": "Spastroji njoftimet",
  "notifications.clear_confirmation": "Jeni i sigurt se doni të spastrohen përgjithmonë krejt njoftimet tuaja?",
  "notifications.clear_title": "Të spastrohen njoftimet?",
  "notifications.column_settings.admin.report": "Raportime të reja:",
  "notifications.column_settings.admin.sign_up": "Regjistrime të reja:",
  "notifications.column_settings.alert": "Njoftime desktopi",
  "notifications.column_settings.favourite": "Të parapëlqyer:",
  "notifications.column_settings.filter_bar.advanced": "Shfaq krejt kategoritë",
  "notifications.column_settings.filter_bar.category": "Shtyllë filtrimesh të shpejta",
  "notifications.column_settings.follow": "Ndjekës të rinj:",
  "notifications.column_settings.follow_request": "Kërkesa të reja për ndjekje:",
  "notifications.column_settings.group": "Grupoji",
  "notifications.column_settings.mention": "Përmendje:",
  "notifications.column_settings.poll": "Përfundime pyetësori:",
  "notifications.column_settings.push": "Njoftime Push",
  "notifications.column_settings.quote": "Ctime:",
  "notifications.column_settings.reblog": "Përforcime:",
  "notifications.column_settings.show": "Shfaqi në shtylla",
  "notifications.column_settings.sound": "Luaj një tingull",
  "notifications.column_settings.status": "Mesazhe të rinj:",
  "notifications.column_settings.unread_notifications.category": "Njoftime të palexuara",
  "notifications.column_settings.unread_notifications.highlight": "Theksoji njoftimet e palexuara",
  "notifications.column_settings.update": "Përpunime:",
  "notifications.filter.all": "Krejt",
  "notifications.filter.boosts": "Përforcime",
  "notifications.filter.favourites": "Të parapëlqyer",
  "notifications.filter.follows": "Ndjekje",
  "notifications.filter.mentions": "Përmendje",
  "notifications.filter.polls": "Përfundime pyetësori",
  "notifications.filter.statuses": "Përditësime prej personash që ndiqni",
  "notifications.grant_permission": "Akordoji leje.",
  "notifications.group": "{count}s njoftime",
  "notifications.mark_as_read": "Vëri shenjë çdo njoftimi si të lexuar",
  "notifications.permission_denied": "S’merren dot njoftime në desktop, ngaqë më herët shfletuesit i janë mohuar lejet për këtë",
  "notifications.permission_denied_alert": "S’mund të aktivizohen njoftimet në desktop, ngaqë lejet e shfletuesit për këtë janë mohuar më herët",
  "notifications.permission_required": "S’merren dot njoftime desktop, ngaqë s’është akorduar leja përkatëse.",
  "notifications.policy.accept": "Pranoji",
  "notifications.policy.accept_hint": "Shfaq njoftime",
  "notifications.policy.drop": "Shpërfille",
  "notifications.policy.drop_hint": "Dërgoje në hiç, mos e pafshim më kurrë",
  "notifications.policy.filter": "Filtrim",
  "notifications.policy.filter_hint": "Dërgoje te kutia e njoftimeve të filtruara",
  "notifications.policy.filter_limited_accounts_hint": "Kufizuar nga moderatorë shërbyesi",
  "notifications.policy.filter_limited_accounts_title": "Llogari të moderuara",
  "notifications.policy.filter_new_accounts.hint": "Krijuar brenda {days, plural, one {një dite} other {# ditësh}} të shkuara",
  "notifications.policy.filter_new_accounts_title": "Llogari të reja",
  "notifications.policy.filter_not_followers_hint": "Përfshi persona që ju kanë ndjekur brenda më pak se {days, plural, one {një dite} other {# ditësh}}",
  "notifications.policy.filter_not_followers_title": "Persona që s’ju ndjekin",
  "notifications.policy.filter_not_following_hint": "Deri sa t’i miratoni dorazi",
  "notifications.policy.filter_not_following_title": "Persona që s’i ndiqni",
  "notifications.policy.filter_private_mentions_hint": "Filtruar, hiq rastin nëse gjendet te përgjigje ndaj përmendjes tuaj, ose nëse dërguesin e ndiqni",
  "notifications.policy.filter_private_mentions_title": "Përmendje private të pakërkuara",
  "notifications.policy.title": "Administroni njoftime nga…",
  "notifications_permission_banner.enable": "Aktivizo njoftime në desktop",
  "notifications_permission_banner.how_to_control": "Për të marrë njoftime, kur Mastodon-i s’është i hapur, aktivizoni njoftime në desktop. Përmes butoni {icon} më sipër, mund të kontrolloni me përpikëri cilat lloje ndërveprimesh prodhojnë njoftime në desktop, pasi të jenë aktivizuar.",
  "notifications_permission_banner.title": "Mos t’ju shpëtojë gjë",
  "onboarding.follows.back": "Mbrapsht",
  "onboarding.follows.empty": "Mjerisht, s’mund të shfaqen përfundime tani. Mund të provoni të përdorni kërkimin, ose të shfletoni faqen e eksplorimit, që të gjeni persona për ndjekje, ose të riprovoni më vonë.",
  "onboarding.follows.next": "Pasuesi: Ujdisni profilin tuaj",
  "onboarding.follows.search": "Kërkoni",
  "onboarding.follows.title": "Që t’ia filloni, ndiqni persona",
  "onboarding.profile.discoverable": "Bëje profilin tim të zbulueshëm",
  "onboarding.profile.discoverable_hint": "Kur zgjidhni të jeni i zbulueshëm në Mastodon, postimet tuaja mund të shfaqen në përfundime kërkimesh dhe gjëra në modë dhe profili juaj mund t’u sugjerohet njerëzve me interesa të ngjashme me ju.",
  "onboarding.profile.display_name": "Emër në ekran",
  "onboarding.profile.display_name_hint": "Emri juaj i plotë, ose ç’të doni…",
  "onboarding.profile.finish": "Përfundoje",
  "onboarding.profile.note": "Jetëshkrim",
  "onboarding.profile.note_hint": "Mund të @përmendni persona të tjerë, ose #hashtagë…",
  "onboarding.profile.title": "Udjisje profili",
  "onboarding.profile.upload_avatar": "Ngarkoni foto profili",
  "onboarding.profile.upload_header": "Ngarkoni krye profili",
  "password_confirmation.exceeds_maxlength": "Fjalëkalimi i ripohuar tejkalon gjatësinë maksimum të fjalëkalimeve",
  "password_confirmation.mismatching": "Fjalëkalimi i ripohuar nuk përkon",
  "picture_in_picture.restore": "Ktheje ku qe",
  "poll.closed": "I mbyllur",
  "poll.refresh": "Rifreskoje",
  "poll.reveal": "Shihni përfundimet",
  "poll.total_people": "{count, plural,one {# person }other {# vetë }}",
  "poll.total_votes": "{count, plural,one {# votë }other {# vota }}",
  "poll.vote": "Votoni",
  "poll.voted": "Votuat për këtë përgjigje",
  "poll.votes": "{votes, plural, one {# votë} other {# vota}}",
  "poll_button.add_poll": "Shtoni një pyetësor",
  "poll_button.remove_poll": "Hiqe pyetësorin",
  "privacy.change": "Rregulloni privatësi mesazhesh",
  "privacy.direct.long": "Gjithkënd i përmendur te postimi",
  "privacy.direct.short": "Përmendje private",
  "privacy.private.long": "Vetëm ndjekësit tuaj",
  "privacy.private.short": "Ndjekës",
  "privacy.public.long": "Cilido që hyn e del në Mastodon",
  "privacy.public.short": "Publik",
  "privacy.quote.anyone": "{visibility}, lejohen citimet",
  "privacy.quote.disabled": "{visibility}, citimet janë çaktivizuar",
  "privacy.quote.limited": "{visibility}, citime të kufizuara",
  "privacy.unlisted.additional": "Ky sillet saktësisht si publik, vetëm se postimi s’do të shfaqet në prurje të drejtpërdrejta, ose në hashtag-ë, te eksploroni, apo kërkim në Mastodon, edhe kur keni zgjedhur të jetë për tërë llogarinë.",
  "privacy.unlisted.long": "Fshehur nga përfundime kërkimi në Mastodon, rrjedha kohore gjërash në modë dhe publike",
  "privacy.unlisted.short": "Publik i qetë",
  "privacy_policy.last_updated": "Përditësuar së fundi më {date}",
  "privacy_policy.title": "Rregulla Privatësie",
  "quote_error.edit": "Kur përpunohet një postim, s’mund të shtohen citime.",
  "quote_error.poll": "Me pyetësorët nuk lejohet citim.",
  "quote_error.private_mentions": "Citimi nuk lejohet me përmendje të drejtpërdrejta.",
  "quote_error.quote": "Lejohet vetëm një citim në herë.",
  "quote_error.unauthorized": "S’jen i autorizuar ta citoni këtë postim.",
  "quote_error.upload": "Me bashkëngjitjet media nuk lejohet citim.",
  "recommended": "E rekomanduar",
  "refresh": "Rifreskoje",
  "regeneration_indicator.please_stand_by": "Ju lutemi, mos u largoni.",
  "regeneration_indicator.preparing_your_home_feed": "Po përgatitet prurja juaj e kreut…",
  "relative_time.days": "{number}d",
  "relative_time.full.days": "{number, plural, one {# ditë} other {# ditë}} më parë",
  "relative_time.full.hours": "{number, plural, one {# orë} other {# orë}} më parë",
  "relative_time.full.just_now": "mu tani",
  "relative_time.full.minutes": "{number, plural, one {# minutë} other {# minuta}} më parë",
  "relative_time.full.seconds": "{number, plural, one {# sekondë} other {# sekonda}} më parë",
  "relative_time.hours": "{number}o",
  "relative_time.just_now": "tani",
  "relative_time.minutes": "{number}m",
  "relative_time.seconds": "{number}s",
  "relative_time.today": "sot",
  "remove_quote_hint.button_label": "E mora vesh",
  "remove_quote_hint.message": "Këtë mund ta bëni një menuja e mundësive {icon}.",
  "remove_quote_hint.title": "Doni të hiqet postimi juaj i cituar?",
  "reply_indicator.attachments": "{count, plural, one {# bashkëngjitje} other {# bashkëngjitje}}",
  "reply_indicator.cancel": "Anuloje",
  "reply_indicator.poll": "Pyetësor",
  "report.block": "Bllokoje",
  "report.block_explanation": "S’do të shihni postime prej tyre. S’do të jenë në gjendje të shohin postimet tuaja, apo t’ju ndjekin. Do të jenë në gjendje të shohin se janë bllokuar.",
  "report.categories.legal": "Ligjore",
  "report.categories.other": "Tjetër",
  "report.categories.spam": "I padëshiruar",
  "report.categories.violation": "Lënda shkel një ose disa rregulla shërbyesi",
  "report.category.subtitle": "Zgjidhni përputhjen më të mirë",
  "report.category.title": "Tregonani se ç’po ndodh me këtë {type}",
  "report.category.title_account": "profil",
  "report.category.title_status": "postim",
  "report.close": "U bë",
  "report.collection_comment": "Pse doni ta raportoni këtë koleksion?",
  "report.comment.title": "Ka ndonjë gjë tjetër që do të duhej ta dinim?",
  "report.forward": "Përcillja {target}",
  "report.forward_hint": "Llogaria është nga një shërbyes tjetër. Të dërgohet edhe një kopje e anonimizuar e raportimit?",
  "report.mute": "Heshtoje",
  "report.mute_explanation": "S’do të shihni postimet e tyre. Ende mund t’ju ndjekin dhe të shohin postimet tuaja dhe s’do ta dinë që janë heshtuar.",
  "report.next": "Pasuesi",
  "report.placeholder": "Komente shtesë",
  "report.reasons.dislike": "S’më pëlqen",
  "report.reasons.dislike_description": "S’është gjë që do të doja ta shihja",
  "report.reasons.legal": "Është i paligjshëm",
  "report.reasons.legal_description": "Besoni se cenon ligjin e vendit tuaj, ose atij të shërbyesit",
  "report.reasons.other": "Është tjetër gjë",
  "report.reasons.other_description": "Problemi nuk hyn te kategoritë e tjera",
  "report.reasons.spam": "Është mesazh i padëshiruar",
  "report.reasons.spam_description": "Lidhje dashakeqe, angazhim i rremë, ose përgjigje të përsëritura",
  "report.reasons.violation": "Cenon rregulla shërbyesi",
  "report.reasons.violation_description": "Jeni i ndërgjegjshëm që cenon rregulla specifike",
  "report.rules.subtitle": "Përzgjidhni gjithçka që ka vend",
  "report.rules.title": "Cilat rregulla po cenohen?",
  "report.statuses.subtitle": "Përzgjidhni gjithçka që ka vend",
  "report.statuses.title": "A ka postime që dëshmojnë problemet e këtij raporti?",
  "report.submission_error": "Raportimi s’u parashtrua dot",
  "report.submission_error_details": "Ju lutemi, kontrolloni lidhjen tuaj në rrjet dhe riprovoni më vonë.",
  "report.submit": "Parashtroje",
  "report.target": "Raportim i {target}",
  "report.thanks.take_action": "Ja mundësitë tuaja për të kontrolluar ç’shihni në Mastodon:",
  "report.thanks.take_action_actionable": "Teksa e shqyrtojmë, mund të ndërmerrni veprim kundër @{name}:",
  "report.thanks.title": "S’doni të shihni këtë?",
  "report.thanks.title_actionable": "Faleminderit për raportimin, do ta shohim.",
  "report.unfollow": "Mos e ndiq më @{name}",
  "report.unfollow_explanation": "Po e ndiqni këtë llogari. Për të mos parë më postimet e tyre te prurja juaj e kreut, ndalni ndjekjen e tyre.",
  "report_notification.attached_statuses": "{count, plural, one {{count} postim} other {{count} postime}} bashkëngjitur",
  "report_notification.categories.legal": "Ligjore",
  "report_notification.categories.legal_sentence": "lëndë e paligjshme",
  "report_notification.categories.other": "Tjetër",
  "report_notification.categories.other_sentence": "tjetër",
  "report_notification.categories.spam": "I padëshiruar",
  "report_notification.categories.spam_sentence": "mesazh i padëshiruar",
  "report_notification.categories.violation": "Cenim rregullash",
  "report_notification.categories.violation_sentence": "cenim rregullash",
  "report_notification.open": "Hape raportimin",
  "search.clear": "Spastroje kërkimin",
  "search.no_recent_searches": "Pa kërkime së fundi",
  "search.placeholder": "Kërkoni",
  "search.quick_action.account_search": "Profile me përputhje me {x}",
  "search.quick_action.go_to_account": "Kalo te profili {x}",
  "search.quick_action.go_to_hashtag": "Kalo te hashtag-u {x}",
  "search.quick_action.open_url": "Hape URL-në në Mastodon",
  "search.quick_action.status_search": "Postime me përputhje me {x}",
  "search.search_or_paste": "Kërkoni, ose hidhni një URL",
  "search_popout.full_text_search_disabled_message": "Jo i passhëm në {domain}.",
  "search_popout.full_text_search_logged_out_message": "E përdorshme vetëm kur keni bërë hyrjen në llogari.",
  "search_popout.language_code": "Kod ISO gjuhe",
  "search_popout.options": "Mundësi kërkimi",
  "search_popout.quick_actions": "Veprime të shpejta",
  "search_popout.recent": "Kërkime së fundi",
  "search_popout.specific_date": "datë e përcaktuar",
  "search_popout.user": "përdorues",
  "search_results.accounts": "Profile",
  "search_results.all": "Krejt",
  "search_results.hashtags": "Hashtag-ë",
  "search_results.no_results": "S’ka përfundime.",
  "search_results.no_search_yet": "Provoni të kërkoni për postime, profile ose hashtag-ë.",
  "search_results.see_all": "Shihni krejt",
  "search_results.statuses": "Mesazhe",
  "search_results.title": "Kërko për “{q}”",
  "server_banner.about_active_users": "Persona që përdorin këtë shërbyes gjatë 30 ditëve të fundit (Përdorues Mujorë Aktivë)",
  "server_banner.active_users": "përdorues aktivë",
  "server_banner.administered_by": "Administruar nga:",
  "server_banner.is_one_of_many": "{domain} është një nga mjaft shërbyes të pavarur Mastodon te të cilët mund të merrni pjesë në Fedivers.",
  "server_banner.more_about_this_server": "Më tepër rreth këtij shërbyesi",
  "server_banner.server_stats": "Statistika shërbyesi:",
  "sign_in_banner.create_account": "Krijoni llogari",
  "sign_in_banner.follow_anyone": "Ndiqni këdo në Fedivers dhe shihni gjithçka në rend kohor. Pa algortime, apo marifete.",
  "sign_in_banner.mastodon_is": "Mastodon-i është rruga më e mirë për të ndjekur se ç’ndodh.",
  "sign_in_banner.sign_in": "Hyni",
  "sign_in_banner.sso_redirect": "Bëni hyrjen, ose Regjistrohuni",
  "skip_links.skip_to_content": "Kalo te lënda kryesore",
  "skip_links.skip_to_navigation": "Kalo te menuja kryesore e lëvizjeve",
  "status.admin_account": "Hap ndërfaqe moderimi për @{name}",
  "status.admin_domain": "Hap ndërfaqe moderimi për {domain}",
  "status.admin_status": "Hape këtë mesazh te ndërfaqja e moderimit",
  "status.all_disabled": "Përforcimet dhe citime janë të çaktivizuara",
  "status.block": "Blloko @{name}",
  "status.bookmark": "Faqeruaje",
  "status.cancel_reblog_private": "Shpërforcojeni",
  "status.cannot_quote": "S’keni leje të citoni këtë postim",
  "status.cannot_reblog": "Ky postim s’mund të përforcohet",
  "status.contains_quote": "Përmban citim",
  "status.context.loading": "Po ngarkohen më tepër përgjigje",
  "status.context.loading_error": "S’u ngarkuan dot përgjigje të reja",
  "status.context.loading_success": "U ngarkuan përgjigje të reja",
  "status.context.more_replies_found": "U gjetën më tepër përgjigje",
  "status.context.retry": "Riprovoni",
  "status.context.show": "Shfaqe",
  "status.continued_thread": "Vazhdoi rrjedhën",
  "status.copy": "Kopjoje lidhjen për te mesazhi",
  "status.delete": "Fshije",
  "status.delete.success": "Postimi u fshi",
  "status.detailed_status": "Pamje e hollësishme bisede",
  "status.direct": "Përmendje private për @{name}",
  "status.direct_indicator": "Përmendje private",
  "status.edit": "Përpunojeni",
  "status.edited": "Përpunuar së fundi më {date}",
  "status.edited_x_times": "Përpunuar {count, plural, one {{count} herë} other {{count} herë}}",
  "status.embed": "Merrni kod trupëzimi",
  "status.favourite": "I vini shenjë si të parapëlqyer",
  "status.favourites_count": "{count, plural, one {{counter} i parapëlqyer} other {{counter} të parapëlqyer}}",
  "status.filter": "Filtroje këtë postim",
  "status.history.created": "{name} u krijua më {date}",
  "status.history.edited": "{name} u përpunua më {date}",
  "status.load_more": "Ngarko më tepër",
  "status.media.open": "Klikoni për hapje",
  "status.media.show": "Klikoni për shfaqje",
  "status.media_hidden": "Me media të fshehur",
  "status.mention": "Përmendni @{name}",
  "status.more": "Më tepër",
  "status.mute": "Heshtoni @{name}",
  "status.mute_conversation": "Heshtoje bisedën",
  "status.open": "Zgjeroje këtë mesazh",
  "status.pin": "Fiksoje në profil",
  "status.quote": "Citojeni",
  "status.quote.cancel": "Anuloje citimin",
  "status.quote_error.blocked_account_hint.title": "Ky postim është i fshehur, ngaqë keni bllokuar @{name}.",
  "status.quote_error.blocked_domain_hint.title": "Ky postim është i fshehur, ngaqë keni bllokuar {domain}.",
  "status.quote_error.filtered": "Fshehur për shkak të njërit nga filtrat tuaj",
  "status.quote_error.limited_account_hint.action": "Shfaqe, sido qoftë",
  "status.quote_error.limited_account_hint.title": "Kjo llogari është fshehur nga moderatorët e {domain}.",
  "status.quote_error.muted_account_hint.title": "Ky postim është i fshehur, ngaqë keni heshtuar @{name}.",
  "status.quote_error.not_available": "Postim që s’mund të kihet",
  "status.quote_error.pending_approval": "Postim pezull",
  "status.quote_error.pending_approval_popout.body": "Në Mastodon mundeni të kontrolloni nëse dikush ju citon a jo. Ky postim është pezull, teksa po marrim miratimin e autorit origjinal.",
  "status.quote_error.revoked": "Postim i hequr nga autori",
  "status.quote_followers_only": "Këtë postim mund ta citojnë vetëm ndjekës",
  "status.quote_manual_review": "Autori do ta shqyrtojë dorazi",
  "status.quote_noun": "Citim",
  "status.quote_policy_change": "Ndryshoni cilët mund të citojnë",
  "status.quote_post_author": "U citua një postim nga @{name}",
  "status.quote_private": "Postimet private s’mund të citohen",
  "status.quotes.empty": "Këtë postim ende s’e ka cituar kush. Kur dikush ta bëjë, do të shfaqet këtu.",
  "status.quotes.local_other_disclaimer": "Citimet e hedhura poshtë nga autori s’do të shfaqen.",
  "status.quotes.remote_other_disclaimer": "Këtu garantohet të shfaqen vetëm citime nga {domain}. Citime të hedhura poshtë nga autori s’do të shfaqen.",
  "status.quotes_count": "{count, plural, one {{counter} citim} other {{counter} citime}}",
  "status.read_more": "Lexoni më tepër",
  "status.reblog": "Përforcojeni",
  "status.reblog_or_quote": "Përforconi ose citoni",
  "status.reblog_private": "Rindajeni me ndjekësit tuaj",
  "status.reblogged_by": "{name} përforcoi",
  "status.reblogs.empty": "Këtë mesazh s’e ka përforcuar njeri deri tani. Kur ta bëjë dikush, kjo do të duket këtu.",
  "status.reblogs_count": "{count, plural, one {{counter} përforcim} other {{counter} përforcime}}",
  "status.redraft": "Fshijeni & rihartojeni",
  "status.remove_bookmark": "Hiqe faqerojtësin",
  "status.remove_favourite": "Hiqe nga të parapëlqyerat",
  "status.remove_quote": "Hiqe",
  "status.replied_in_thread": "U përgjigj te rrjedha",
  "status.replied_to": "Iu përgjigj {name}",
  "status.reply": "Përgjigjuni",
  "status.replyAll": "Përgjigjuni rrjedhës",
  "status.report": "Raportojeni @{name}",
  "status.request_quote": "Kërkoni të citohet",
  "status.revoke_quote": "Hiqe postimin tim nga postimi i @{name}",
  "status.sensitive_warning": "Lëndë rezervat",
  "status.share": "Ndajeni me të tjerë",
  "status.show_less_all": "Shfaq më pak për të tërë",
  "status.show_more_all": "Shfaq më tepër për të tërë",
  "status.show_original": "Shfaq origjinalin",
  "status.title.with_attachments": "{user} postoi {attachmentCount, plural, one {një bashkëngjitje} other {{attachmentCount} bashkëngjitje}}",
  "status.translate": "Përktheje",
  "status.translated_from_with": "Përkthyer nga {lang} duke përdorur {provider}",
  "status.uncached_media_warning": "S’ka paraparje",
  "status.unmute_conversation": "Ktheji zërin bisedës",
  "status.unpin": "Shfiksoje nga profili",
  "subscribed_languages.lead": "Pas ndryshimit, te kreu juaj dhe te rrjedha kohore liste do të shfaqen vetëm postime në gjuhët e përzgjedhura. Që të merrni postime në krejt gjuhë, mos përzgjidhni gjë.",
  "subscribed_languages.save": "Ruaji ndryshimet",
  "subscribed_languages.target": "Ndryshoni gjuhë pajtimesh për {target}",
  "tabs_bar.home": "Kreu",
  "tabs_bar.menu": "Menu",
  "tabs_bar.notifications": "Njoftime",
  "tabs_bar.publish": "Postimi i Ri",
  "tabs_bar.search": "Kërkim",
  "tag.remove": "Hiqe",
  "terms_of_service.effective_as_of": "Hyn në fuqi që prej {date}",
  "terms_of_service.title": "Kushte Shërbimi",
  "terms_of_service.upcoming_changes_on": "Ndryshime të ardhshme më {date}",
  "time_remaining.days": "Edhe {number, plural, one {# ditë} other {# ditë}}",
  "time_remaining.hours": "Edhe {number, plural, one {# orë} other {# orë}}",
  "time_remaining.minutes": "Edhe {number, plural, one {# minutë} other {# minuta}}",
  "time_remaining.moments": "Çaste të mbetur",
  "time_remaining.seconds": "Edhe {number, plural, one {# sekondë} other {# sekonda}}",
  "trends.counter_by_accounts": "{count, plural, një {{counter} person} other {{counter} vetë}} në {days, plural, një {day} other {{days} ditë}} të kaluar",
  "trends.trending_now": "Prirjet e tashme",
  "ui.beforeunload": "Skica juaj do të humbë, nëse dilni nga Mastodon-i.",
  "units.short.billion": "{count}Md",
  "units.short.million": "{count}Ml",
  "units.short.thousand": "{count}K",
  "upload_area.title": "Që të ngarkohet, merreni & vëreni",
  "upload_button.label": "Shtoni figura, një video ose një kartelë audio",
  "upload_error.limit": "U tejkalua kufi ngarkimi kartelash.",
  "upload_error.poll": "Me pyetësorët s’lejohet ngarkim kartelash.",
  "upload_error.quote": "Nuk lejohet ngarkim kartelash me citime.",
  "upload_form.drag_and_drop.instructions": "Që të merrni një bashkëngjitje media, shtypni tastin Space ose Enter. Teksa bëhet tërheqje, përdorni tastet shigjetë për ta shpënë bashkëngjitjen media në cilëndo drejtori që doni. Shtypni sërish Space ose Enter që të lihet bashkëngjitja media në pozicionin e vet të ri, ose shtypni Esc, që të anulohet veprimi.",
  "upload_form.drag_and_drop.on_drag_cancel": "Tërheqja u anulua. Bashkëngjitja media {item} u la.",
  "upload_form.drag_and_drop.on_drag_end": "Bashkëngjitja media {item} u la.",
  "upload_form.drag_and_drop.on_drag_over": "Bashkëngjitja media {item} u lëviz.",
  "upload_form.drag_and_drop.on_drag_start": "U mor bashkëngjitja media {item}.",
  "upload_form.edit": "Përpunoni",
  "upload_progress.label": "Po ngarkohet…",
  "upload_progress.processing": "Po përpunon…",
  "username.taken": "Ai emër përdoruesi është zënë. Provoni tjetër",
  "video.close": "Mbylle videon",
  "video.download": "Shkarkoje kartelën",
  "video.exit_fullscreen": "Dil nga mënyra Sa Krejt Ekrani",
  "video.expand": "Zgjeroje videon",
  "video.fullscreen": "Sa krejt ekrani",
  "video.hide": "Fshihe videon",
  "video.mute": "Heshtoje",
  "video.pause": "Ndalesë",
  "video.play": "Luaje",
  "video.skip_backward": "Anashkalo pararendësen",
  "video.skip_forward": "Anashkalo pasardhësen",
  "video.unmute": "Hiqi heshtimin",
  "video.volume_down": "Ulje volumi",
  "video.volume_up": "Ngritje volumi",
  "visibility_modal.button_title": "Caktoni dukshmëri",
  "visibility_modal.direct_quote_warning.text": "Nëse ruani rregullimet e tanishme, citimi i trupëzuar do të shndërrohet në një lidhje.",
  "visibility_modal.direct_quote_warning.title": "Citimet s’mund të trupëzohen në përmendje private",
  "visibility_modal.header": "Dukshmëri dhe ndërveprim",
  "visibility_modal.helper.direct_quoting": "Përmendje private të krijuara në Mastodon s’mund të citohen nga të tjerë.",
  "visibility_modal.helper.privacy_editing": "Dukshmëria s’mund të ndryshohet pasi postimi botohet.",
  "visibility_modal.helper.privacy_private_self_quote": "Citimet nga ju vetë të postime private s’mund të bëhen publike.",
  "visibility_modal.helper.private_quoting": "Postime vetëm për ndjekësit, të krijuara në Mastodon s’mund të citohen nga të tjerë.",
  "visibility_modal.helper.unlisted_quoting": "Kur njerëzit ju citojnë, nga rrjedha kohore e gjërave në modë do të kalohen si të fshehura edhe postimet e tyre.",
  "visibility_modal.instructions": "Kontrolloni cilët mund të ndërveprojnë me këtë postim. Rregullime mund të aplikooni edhe mbi krejt postimet e ardshme, që nga <link>Parapëlqime > Parazgjedhje postimi</link>.",
  "visibility_modal.privacy_label": "Dukshmëri",
  "visibility_modal.quote_followers": "Vetëm ndjekës",
  "visibility_modal.quote_label": "Cilët mund të citojnë",
  "visibility_modal.quote_nobody": "Thjesht unë",
  "visibility_modal.quote_public": "Cilido",
  "visibility_modal.save": "Ruaje"
}
